import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Checkbox, Input, message, Radio, Select, Spin, Table, Tooltip, Upload } from "antd";
import Dragger from "antd/es/upload/Dragger";
import { RxGlobe } from "react-icons/rx";
import { IoMdCopy } from "react-icons/io";
import { BiSolidTrash } from "react-icons/bi";
import { FaRegTrashAlt } from "react-icons/fa";
import { IoOpenOutline } from "react-icons/io5";
import { ImFolderUpload } from "react-icons/im";
import { FaUpload, FaXmark, FaFileCirclePlus } from "react-icons/fa6";
import { PiExportBold, PiWarningCircleLight } from "react-icons/pi";

import './style.scss';
import uris from "../../../config/uris";
import TextArea from "antd/es/input/TextArea";
import getBase64 from "../../../helpers/base64";
import { ConfirmationModal } from "../output-review";
import CustomModal from "../../../assets/component/modal";
import CustomTable from "../../../assets/component/table";
import PDFPreview from "../../../assets/component/pdf-preview";
import { antIcon } from "../../custom-playbook/manage-playbook";
import Breadcrumbs from "../../../assets/component/breadcrumbs";
import ManageFilters from "../../../assets/component/manage-filters";
import ESGSourceIcon from "../../../assets/images/ESG-Chat-Source-Icon.svg";
import { entityFilesList, entityFilesListReset, entityList } from "../../../store/slices/gemini/get-entities";
import { resetFilterValueNavigationState } from "../../../store/slices/gemini/filter-value";
import { UpdateDocsData, updateDocsDataReset } from "../../../store/slices/gemini/update-docs-data";
import { deleteFileReset, DeleteUploadedFile } from "../../../store/slices/gemini/delete-uploaded-file";
import { DownloadFailedFile, downloadFailedFilesReset } from "../../../store/slices/gemini/failed-files";
import { FileValidationAction, fileValidationReset } from "../../../store/slices/gemini/file-validation";
import { UpdateDocsFormData, updateDocsFormdataReset } from "../../../store/slices/gemini/update-docs-formdata";
import { CompleteReview, completeReviewReset, ReviewFile, reviewFileReset } from "../../../store/slices/gemini/review-file";
import { DocReviewExportAction, docReviewExportReset } from "../../../store/slices/gemini/doc-review-export";

message.config({ maxCount: 1 })

const menuData = {
    title: 'Doc Review',
    parentMenu: {
        name: 'Review',
        link: uris?.entityList,
    },
    subMenu: {
        name: 'Doc Review',
        link: uris?.reviewEntities,
    },
}

const tableHeaderData = [
    {
        title: 'File Name',
        dataIndex: 'fileName',
        key: 'fileName',
        width: '15%',
        sorter: (a, b) => a.fileNameRaw.localeCompare(b.fileNameRaw),
        render: (_, record) => record.fileName,
    },
    {
        title: 'File Count',
        dataIndex: 'fileCount',
        key: 'fileCount',
        width: '6%',
        sorter: {
            compare: (a, b) => a.fileCount - b.fileCount,
            multiple: 3,
        },
    },
    {
        title: 'Message',
        dataIndex: 'message',
        key: 'message',
        width: '15%',
        sorter: (a, b) => a.message.localeCompare(b.message),
    },
    {
        title: 'Entity Name',
        dataIndex: 'entityName',
        key: 'entityName',
        width: '18%',
        sorter: (a, b) => a.entityName.localeCompare(b.entityName),
    },
    {
        title: 'Assessment Type',
        dataIndex: 'assessmentType',
        key: 'assessmentType',
        width: '10%',
        sorter: (a, b) => a.assessmentType.localeCompare(b.assessmentType),
    },
    {
        title: 'Parent',
        dataIndex: 'parentRaw',
        key: 'parent',
        width: '5%',
        sorter: (a, b) => a.parentRaw.localeCompare(b.parentRaw),
    },
    {
        title: 'Format',
        dataIndex: 'format',
        key: 'isWebpage',
        width: '5%',
    },
    {
        title: 'Review Status',
        dataIndex: 'reviewStatus',
        key: 'reviewStatus',
        width: '8%',
        sorter: (a, b) => a.reviewStatus.localeCompare(b.reviewStatus),
    },
    {
        title: 'Reviewed By',
        dataIndex: 'reviewedBy',
        key: 'reviewedBy',
        width: '10%',
        sorter: (a, b) => a.reviewedBy.localeCompare(b.reviewedBy),
    },
    {
        title: '',
        dataIndex: 'actions',
        key: 'actions',
        width: '18%',
    }
]
const NestedDocumentsTable = ({ documentList, onFilePreview, setDeleteFile, setShowDeleteFileModal, copiedId, setCopiedId, showDelete = true }) => {

    const columns = [
        {
            title: "File Name",
            dataIndex: "fileName",
            key: "fileName",
            width: "30%"
        },
        {
            title: "File URL",
            dataIndex: "fileUrl",
            key: "fileUrl",
            width: "30%"
        },
        {
            title: "Section URL",
            dataIndex: "sectionUrl",
            key: "sectionUrl",
            width: "30%"
        },
        {
            title: "Identifier",
            dataIndex: "identifier",
            key: "identifier",
            width: "15%"
        },
        ...(showDelete ? [{
            title: '',
            dataIndex: 'actions',
            key: 'actions',
            width: '5%'
        }] : []),
    ];

    const handleDeleteFile = (file) => {
        setDeleteFile(file);
        setShowDeleteFileModal(true);
    }

    const formattedData = documentList?.map((doc, index) => ({
        key: index,
        fileName: (
            <div
                className="filename"
                onClick={() => onFilePreview(doc?.nestedSourceId, doc?.fileName)}
            >
                {doc?.fileName}
            </div>
        ),
        fileUrl: (
            <a className="filename" href={doc?.fileUrl} rel="noreferrer" target="_blank">
                {truncateUrl(doc?.fileUrl)}
            </a>
        ),
        sectionUrl: (
            <a className="filename" href={doc?.sectionUrl} rel="noreferrer" target="_blank">
                {truncateUrl(doc?.sectionUrl)}
            </a>
        ),
        identifier: (
            <div className={`identifier ${copiedId === doc?.nestedSourceId ? "copy" : ""}`} onClick={() => handleCopyIdentifier(doc?.nestedSourceId, setCopiedId)}>
                {copiedId === doc?.nestedSourceId ? 'Copied' : 'Copy'} <span><IoMdCopy /></span>
            </div>
        ),
        actions: (
            <div className="action-icon-container" onClick={() => handleDeleteFile(doc)}><span className="action-delete-icon">
                <BiSolidTrash />
            </span></div>
        )
    }));

    return <Table dataSource={formattedData} columns={columns} pagination={false} />;
};

const truncateUrl = (url) => {
    if (!url) return "";
    const start = url.slice(0, 40);
    const end = url.slice(-20);
    return `${start}...${end}`;
}

const handleCopyIdentifier = (textToCopy, setCopiedId) => {
    if (!textToCopy) return;
    navigator.clipboard.writeText(textToCopy)
    setCopiedId(textToCopy)
    setTimeout(() => setCopiedId(null), 2000);
}

// Utility: Convert base64 to Blob
function base64ToBlob(base64Data, contentType = 'application/pdf') {
    const byteCharacters = atob(base64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512);
        const byteNumbers = new Array(slice.length).fill().map((_, i) => slice.charCodeAt(i));
        byteArrays.push(new Uint8Array(byteNumbers));
    }

    return new Blob(byteArrays, { type: contentType });
}

const getMimeTypeFromExtension = (fileName) => {
    const extension = fileName.split('.').pop().toLowerCase();
    const mimeTypes = {
        pdf: 'application/pdf',
        xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        xls: 'application/vnd.ms-excel',
        csv: 'text/csv',
        docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        doc: 'application/msword'
    };
    return mimeTypes[extension] || 'application/octet-stream';
};

const variableNotesHeader = [
    {
        title: 'Variable',
        dataIndex: 'variable',
        key: 'variable',
        width: '15%',
        sorter: (a, b) => a.variable.localeCompare(b.variable),
    },
    {
        title: 'Notes',
        dataIndex: 'notes',
        key: 'notes',
        width: '85%',
        sorter: (a, b) => a.notes.localeCompare(b.notes),
    },
]

const FileReviewModal = ({ selectedSource, setShouldDownload, copiedId, setCopiedId, setDeleteFile, clearTrigger, setShowUploadConfirmationModal, fileValidationLoading, setShowDeleteFileModal, handleClose, isLoading, documentList, setDocumentList, linkStatus, setLinkStatus, fileStatus, setFileStatus, setShowPDFPreview }) => {

    const [reason, setReason] = useState("")
    const [formErrors, setFormErrors] = useState({})
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [errors, setErrors] = useState({});
    const [selectedReason, setSelectedReason] = useState(null);
    const [urlFields, setUrlFields] = useState([{ fileUrl: "", sectionUrl: selectedSource?.sourceUrl, fileName: "", base64: "" }]);
    const [indexId, setIndexId] = useState(0)

    const dispatch = useDispatch();

    const fileUploadRefs = useRef([]);

    const maxFileSize = 100;
    const conversionOfMBtoBytes = 1048576;

    const linkStatusOptions = [
        { label: "Valid", value: "Valid" },
        { label: "Invalid", value: "Invalid" },
    ]

    const reasonOptions = [
        { label: "OCR Issue", value: "OCR Issue" },
        { label: "Password-protected/encrypted", value: "Password-protected/encrypted" },
        { label: "Cannot open the file", value: "Cannot open the file" },
        { label: "File appears blank or corrupted", value: "File appears blank or corrupted" },
        { label: "Layout/formatting issues after conversion", value: "Layout/formatting issues after conversion" }
    ]

    const detailsOptions = [
        { label: "Convertible", value: "Convertible" },
        { label: "Non-Convertible", value: "Non-Convertible" },
    ]

    const handleFilePreview = (file) => {

        dispatch(downloadFailedFilesReset())
        const payload = {
            clientSourceListId: file?.nestedSourceId || file?.evidenceId
        }

        dispatch(DownloadFailedFile(payload))
        if (file?.fileName?.endsWith(".pdf") || file?.fileName?.endsWith(".zip") || file?.s3FileName?.endsWith(".pdf") || file?.s3FileName?.endsWith(".zip")) {
            setShowPDFPreview(true)
        }
    }

    const checkValidFile = (file) => {
        const formData = new FormData();
        formData.append("file", file)
        formData.append("fileName", file?.name)
        dispatch(FileValidationAction(formData))
    }

    const handlePreview = (fileId, fileName) => {
        dispatch(downloadFailedFilesReset())
        const payload = {
            clientSourceListId: fileId
        }
        dispatch(DownloadFailedFile(payload))
        if (fileName?.endsWith(".pdf") || fileName?.endsWith(".zip")) {
            setShowPDFPreview(true)
        } else {
            setShouldDownload(true);
        }
    }

    const handleFileStatus = (e) => {
        setFileStatus(e)
        if (e) clearError("fileStatus")
    }

    const handleReason = (e) => {
        setSelectedReason(e);
        if (e) clearError("reason");
    }

    const handleClearFile = (fileToRemove) => {
        setUploadedFiles(prev => prev.filter(f => f !== fileToRemove))
    }

    const formatFile = async (currentFile) => {
        const convertToBase64 = (file) => {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file?.originFileObj);
                reader.onload = () => resolve(reader.result);
                reader.onerror = (error) => reject(error);
            });
        };

        const base64File = await convertToBase64(currentFile);

        const structuredFile = {
            base64: base64File.split(";base64,")[1],
            fileName: currentFile.name,
        };

        return structuredFile;
    };

    const clearError = (field) => {
        setErrors(prevErrors => ({
            ...prevErrors,
            [field]: ""
        }));
    };

    function debounce(func, delay) {
        let timeoutId;
        return (...args) => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                func.apply(this, args);
            }, delay);
        };
    }

    const handleUploadFiles = async (files) => {
        clearError("file")
        checkValidFile(files[0]?.originFileObj)
        const fileSizeLimit = maxFileSize * conversionOfMBtoBytes;
        let structured_files = [...uploadedFiles]

        if (!selectedSource?.isWebpage && (structured_files.length + files.length) > 1) {
            message.error("Only one file can be uploaded");
            return;
        }

        for (let i = 0; i < files.length; i++) {
            const single_file = files[i];
            if ((single_file.size <= fileSizeLimit)) {
                const formattedFile = await formatFile(single_file);
                const fileExistInFolder = uploadedFiles?.some(oldFile => (oldFile?.title?.includes(formattedFile.fileName)));
                if (!fileExistInFolder)
                    structured_files.push(formattedFile)
                else
                    message.error("File already exists");
            }
        }
        setUploadedFiles(structured_files);
    };

    let errorDisplayed = false;
    const configureDragAndDrop = {
        name: 'file',
        multiple: false,
        beforeUpload: (file, fileList) => {
            if (fileList.length > 1) {
                if (!errorDisplayed) {
                    message.error('You can only upload one file at a time.');
                    errorDisplayed = true;
                }
                return Upload.LIST_IGNORE;
            }

            // Validate file type using MIME type
            const allowedMimeTypes = [
                'application/pdf',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'application/vnd.ms-excel',
                'text/csv',
                'application/csv',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/msword'
            ];

            if (!allowedMimeTypes.includes(file.type)) {
                message.error(`${file.name} is not a supported file type.`);
                return Upload.LIST_IGNORE;
            }

            return false;
        },
        fileList: [], // Initial empty file list
        accept: '.pdf,.xlsx,.xls,.csv,.docx,.doc', // Restrict file picker options (for UI)
        onChange: debounce(async (info) => {
            if (info?.file?.status === 'removed') {
                return;
            }
            const validFiles = info.fileList.slice(0, 1);
            if (validFiles.length <= 1) {
                await handleUploadFiles(validFiles);
            } else {
                message.error('You can only upload one file at a time.');
            }

            errorDisplayed = false;
        }, 300)
    };

    const handleLinkStatusChange = (e) => {
        setLinkStatus(e)
    }

    const handleSubmit = () => {
        const isWebpage = selectedSource?.isWebpage;

        if (isWebpage) {
            if (linkStatus === "Invalid") {
                if (!reason?.trim()) {
                    setFormErrors((prev) => ({
                        ...prev,
                        reason: "Please enter the reason for invalid link",
                    }));
                    return;
                }
            } else if (urlFields.some((f) => !f.fileUrl || !f.sectionUrl || !f.fileName)) {
                message.error("Please fill all the fields/upload a file before submitting");
                return;
            }

        } else {
            const errors = {};
            if (
                (uploadedFiles.length === 0 && fileStatus === "Convertible") &&
                selectedSource.uploadStatus !== "Success"
            ) {
                errors.file = "Please upload a file(s)";
            }

            if (!selectedReason && fileStatus === "Non-Convertible") {
                errors.reason = "Please enter the reason";
            }

            setErrors(errors);

            if (Object.keys(errors).length > 0) return;
        }

        const formData = new FormData();
        const payload = {};

        if (isWebpage) {
            payload.isValid = linkStatus === "Valid";
            payload.reason = linkStatus === "Invalid" ? reason : "";
            payload.clientSourceListId = selectedSource?.evidenceId;

            if (linkStatus === "Valid") {
                const fileDetails = [];

                urlFields.forEach((f, index) => {
                    const mimeType = getMimeTypeFromExtension(f?.fileName);
                    const blob = base64ToBlob(f?.base64, mimeType);
                    formData.append("files", new File([blob], f.fileName, { type: mimeType }));
                    fileDetails.push({
                        index,
                        fileUrl: f.fileUrl,
                        sectionUrl: f.sectionUrl,
                    });
                });

                payload.fileDetails = fileDetails;
            }

        } else {
            payload.isConvertedFile = fileStatus !== "Non-Convertible";
            payload.clientSourceListId = selectedSource?.evidenceId;

            if (fileStatus === "Non-Convertible") {
                payload.reason = selectedReason;
            } else {
                const fileDetails = [];
                uploadedFiles.forEach((f, index) => {
                    const mimeType = getMimeTypeFromExtension(f?.fileName);
                    const blob = base64ToBlob(f?.base64, mimeType);
                    formData.append("files", new File([blob], f.fileName, { type: mimeType }));
                    fileDetails.push({ index });
                });
                payload.fileDetails = fileDetails;
            }
        }
        formData.append("payload", JSON.stringify(payload));
        dispatch(ReviewFile(formData));
    };


    const handleFileUpload = (index) => {
        setIndexId(index)
        if (fileUploadRefs.current[index]) {
            fileUploadRefs.current[index].click();
        }
    };

    const handleFileChange = async (index, field, input, event) => {
        const file = event.target.files[0];
        event.target.value = "";
        if (file) {
            const fileType = file.type;
            const fileSizeLimit = 100 * 1024 * 1024; // 100MB
            if (file.size > fileSizeLimit) {
                message.error("File size exceeds 100MB limit");
                return;
            }
            const allowedMimeTypes = [
                'application/pdf',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'application/vnd.ms-excel',
                'text/csv',
                'application/csv',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/msword'
            ];
            if (allowedMimeTypes?.includes(fileType)) {
                checkValidFile(file)
                const updatedFields = [...urlFields];
                updatedFields[index][field] = file.name;
                setUrlFields(updatedFields);

                setFormErrors((prevErrors) => ({
                    ...prevErrors,
                    [input]: ""
                }))
                try {
                    const base64 = await getBase64(file);
                    const updatedFieldsWithBase64 = [...urlFields];
                    updatedFieldsWithBase64[index][input] = base64.split(";base64,")[1];
                    setUrlFields(updatedFieldsWithBase64);
                } catch (error) {
                    message.error("Error converting file to base64:", error);
                }
            } else {
                message.error(`${file.name} is not a supported file type.`);
            }
        }
    };

    const handleClear = (index, file, base64) => {
        const updatedFields = [...urlFields];
        updatedFields[index][file] = "";
        updatedFields[index][base64] = "";
        setUrlFields(updatedFields);
    }

    const handleDelete = (field, index) => {
        const updatedFields = urlFields.filter((_, i) => i !== index);
        fileUploadRefs.current.splice(index, 1);
        setUrlFields(updatedFields)
    }

    const handleUpdateReason = ({ target: { value } }) => {
        setReason(value)
        if (value) {
            setFormErrors((prevErrors) => ({
                ...prevErrors,
                reason: ""
            }))
        }
    }

    const handleAddField = () => {
        if (urlFields.length >= 10) {
            message.error("Maximum Limit Reached")
            return;
        } else {
            setUrlFields([...urlFields, { fileUrl: "", sectionUrl: selectedSource?.sourceUrl }]);
        }
    };

    const handleFieldChange = (index, field, value) => {
        const updatedFields = [...urlFields];
        updatedFields[index][field] = value;
        setUrlFields(updatedFields);
    };

    useEffect(() => {
        if (selectedSource?.isWebpage) {
            setLinkStatus("Valid")
        } else {
            setFileStatus("Convertible")
        }
        if (selectedSource?.sourceUrl) {
            setUrlFields([{ fileUrl: "", sectionUrl: selectedSource?.sourceUrl, fileName: "", base64: "" }]);
        }
        if (selectedSource?.nestedDocumentsData) {
            setDocumentList(selectedSource?.nestedDocumentsData)
        }
    }, [selectedSource]);

    useEffect(() => {
        if (clearTrigger) {
            setUploadedFiles([])
            handleClear(indexId, "fileName", "base64")
            setShowUploadConfirmationModal(false)
            dispatch(fileValidationReset());
        }
    }, [clearTrigger])

    return (
        <div className="webpage-review-main">
            <div className="message-wrapper">
                <div className="input-label">Message:</div>
                <div className="content">{selectedSource?.uploadStatusMessage}</div>
            </div>
            <div className="link-status-section">
                <div className="input-wrapper">
                    <div className="input-label">
                        {selectedSource?.isWebpage ? "Link" : "File"}
                    </div>
                    <div className="link" title={selectedSource?.isWebpage && selectedSource?.sourceUrl}>
                        {selectedSource?.isWebpage ? (<a className="web-link" href={selectedSource?.sourceUrl} rel="noreferrer" target="_blank">
                            {truncateUrl(selectedSource?.sourceUrl)}
                            <span className="link-icon"><IoOpenOutline /></span>
                        </a>) : (
                            <div className="file-name" title={selectedSource?.s3FileName} onClick={() => { handleFilePreview(selectedSource) }}>{selectedSource?.s3FileName?.endsWith('.zip') ? `${selectedSource?.s3FileName} / ${selectedSource?.additionalFields?.extractedFileName}` : selectedSource?.s3FileName}</div>
                        )}
                    </div>
                </div>
                <div className={`input-wrapper ${selectedSource?.isWebpage ? "link-status" : ""}`}>
                    <div className="input-label">
                        {selectedSource?.isWebpage ? "Link Status" : "File Status"}
                    </div>
                    <div className="input-container">
                        <Select
                            showSearch
                            className="filter-select"
                            options={selectedSource?.isWebpage ? linkStatusOptions : detailsOptions}
                            onChange={selectedSource?.isWebpage ? handleLinkStatusChange : handleFileStatus}
                            value={selectedSource?.isWebpage ? linkStatus : fileStatus}
                            placeholder="Select Status"
                            filterOption={(input, option) => option?.label?.toLowerCase()?.includes(input?.toLowerCase())}
                        />
                    </div>
                </div>
                <div className="identifier-section">
                    <div className="input-label">
                        Identifier
                    </div>
                    <div className={`identifier ${copiedId === selectedSource?.evidenceId ? "copy" : ""}`} onClick={() => handleCopyIdentifier(selectedSource?.evidenceId, setCopiedId)}>
                        {copiedId === selectedSource?.evidenceId ? 'Copied' : 'Copy'} <span><IoMdCopy /></span>
                    </div>
                </div>
            </div>
            <div className="entity-details-section">
                <div className="entity-details-wrapper">
                    <div className="input-label">Entity Account Name</div>
                    <div className="input-container">{selectedSource?.entity_account_name}</div>
                </div>
                <div className="entity-details-wrapper">
                    <div className="input-label">Entity Manager</div>
                    <div className="input-container">{selectedSource?.entity_manager}</div>
                </div>
                <div className="entity-details-wrapper">
                    <div className="input-label">Entity Name</div>
                    <div className="input-container">{selectedSource?.entityName}</div>
                </div>
            </div>
            <div className="variable-notes-section">
                <Table
                    pagination={false}
                    dataSource={Object.entries(selectedSource?.notes || {}).map(([key, value]) => ({
                        key,
                        variable: key,
                        notes: value
                    }))}
                    columns={variableNotesHeader}
                />
            </div>
            {(selectedSource?.isWebpage && selectedSource?.nestedDocumentsData?.length > 0) && <div className="document-list-section">
                {documentList?.length > 0 && (
                    <>
                        <div className="document-list-header">Uploaded Documents </div>
                        <NestedDocumentsTable
                            documentList={selectedSource?.nestedDocumentsData}
                            onFilePreview={handlePreview}
                            setDeleteFile={setDeleteFile}
                            setShowDeleteFileModal={setShowDeleteFileModal}
                            copiedId={copiedId}
                            setCopiedId={setCopiedId}
                        />
                    </>
                )}
            </div>}
            <div className="upload-comment-section">
                {selectedSource?.isWebpage ? (
                    linkStatus === "Invalid" ? (
                        <div className="reason-area">
                            <div className="input-label">
                                Reason <span>*</span>
                            </div>
                            <TextArea
                                placeholder="Enter your reason..."
                                rows={4}
                                onChange={handleUpdateReason}
                            />
                            <div className="error-message">{formErrors?.reason}</div>
                        </div>
                    ) : (
                        <>
                            {urlFields?.map((field, index) => (
                                <div key={index} className="file-upload-section">
                                    <div className="url-fields-wrapper">
                                        <div className="section-url">
                                            <div className="input-label">
                                                Section URL <span>*</span>
                                            </div>
                                            <TextArea
                                                rows={2}
                                                value={field.sectionUrl}
                                                placeholder="Enter url"
                                                onChange={(e) =>
                                                    handleFieldChange(index, "sectionUrl", e.target.value)
                                                }
                                            />
                                        </div>
                                        <div className="source-url">
                                            <div className="input-label">
                                                File URL <span>*</span>
                                            </div>
                                            <TextArea
                                                rows={2}
                                                value={field.fileUrl}
                                                placeholder="Enter url"
                                                onChange={(e) =>
                                                    handleFieldChange(index, "fileUrl", e.target.value)
                                                }
                                            />
                                        </div>
                                        {urlFields.length > 1 && (
                                            <div className="row-delete" onClick={() => handleDelete(field, index)}>
                                                <FaRegTrashAlt />
                                            </div>
                                        )}
                                    </div>
                                    <div className="file-upload-wrapper">
                                        <div className="file-upload" title="upload" onClick={() => handleFileUpload(index)}>
                                            <ImFolderUpload />
                                        </div>
                                        <input
                                            ref={(el) => (fileUploadRefs.current[index] = el)}
                                            type="file"
                                            accept=".pdf,.xlsx,.xls,.csv,.docx,.doc"
                                            style={{ display: "none" }}
                                            onChange={(e) => handleFileChange(index, "fileName", "base64", e)}
                                        />
                                        {(fileValidationLoading && (indexId === index)) ? (
                                            <Spin size="small" />
                                        ) : (field.fileName && (
                                            <div className="file-name-wrapper">
                                                <div className="file-name" title={field.fileName}>
                                                    {field.fileName}
                                                    <span className="clear-button" onClick={() => handleClear(index, "fileName", "base64")}>
                                                        <FaXmark />
                                                    </span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </>
                    )
                ) : fileStatus === "Non-Convertible" ? (
                    <div className="reason-select-area">
                        <div className="text-area-header">
                            Reason<span>*</span>
                        </div>
                        <div className="input-container">
                            <Select
                                showSearch
                                allowClear
                                placeholder="Choose Reason"
                                className="filter-select"
                                options={reasonOptions || []}
                                onChange={handleReason}
                                value={selectedReason}
                            />
                        </div>
                        <div className="error-message">{errors.reason}</div>
                    </div>
                ) : (
                    <div className="upload-file-wrapper">
                        <div className="upload-container">
                            <Dragger
                                {...configureDragAndDrop}
                                disabled={(selectedSource?.status || selectedSource.uploadStatus) === "Success"}
                            >
                                <div className="dragger-wrapper">
                                    <div className="upload-icon">
                                        <FaUpload />
                                    </div>
                                    <div className="upload-main-text">Click or drag file to upload</div>
                                    <div className="upload-description-text">
                                        Maximum file size to upload is {maxFileSize}MB
                                    </div>
                                    <div className="accepted-files">Accepted File Type: .pdf, .xls, .xlsx, .csv, .docx, .doc</div>
                                </div>
                            </Dragger>
                            <div className="error-message">{errors.file}</div>
                        </div>
                        {
                            fileValidationLoading ? <Spin size="small" /> : (
                                <div className="file-name-wrapper">
                                    <div className="file-name">
                                        {uploadedFiles.length > 0 &&
                                            uploadedFiles.map((f, i) => (
                                                <div className="names" key={i}>
                                                    {f.fileName}
                                                    <span className="clear-button" onClick={() => handleClearFile(f)}>
                                                        <FaXmark />
                                                    </span>
                                                </div>
                                            ))}
                                    </div>
                                </div>
                            )
                        }
                    </div>
                )}
            </div>
            {(selectedSource?.isWebpage && linkStatus !== "Invalid") && <div className="add-button-wrapper">
                <div className="form-button-default" onClick={handleAddField}>Add</div>
            </div>}
            <div className="actions-container">
                <div className="button-wrapper submit" onClick={handleSubmit}>
                    {isLoading ? (
                        <Spin
                            className={`submit-loading ${fileStatus === "Non-Convertible" ? "review" : ""}`}
                            indicator={antIcon}
                        />
                    ) : (
                        fileStatus === "Non-Convertible" || linkStatus === "Invalid"
                            ? "Complete Review"
                            : "Submit"
                    )}
                </div>
                <div className="button-wrapper cancel" onClick={handleClose}>Cancel</div>
            </div>
        </div>
    )
}

const ValidateModal = ({ handleClose, selectedSource, setShouldDownload, clearTrigger, setShowUploadConfirmationModal, setShowDocSubmissionModal, copiedId, setCopiedId, radioValues, setRadioValues, rejectReason, setRejectReason, setShowReviewSubmissionModal, showPDFPreview, setShowPDFPreview, fileValidationLoading, completeReviewLoading, documentList, setDocumentList, setDeleteFile, setShowDeleteFileModal }) => {
    const [coverSheet, setCoverSheet] = useState(false);
    const [isNonEnglish, setIsNonEnglish] = useState(false);
    const [applicableVariables, setApplicableVariables] = useState([]);
    const [matchedEntityValue, setMatchedEntityValue] = useState("");
    const [entityFormErrors, setEntityFormErrors] = useState({
        entityRadioValue: "",
        entityReason: "",
        matchedEntity: ""
    });
    const [yearFormErrors, setYearFormErrors] = useState({
        yearRadioValue: {},
        yearReason: {}
    });
    const [showFyForm, setShowFyForm] = useState(false);
    const [file, setFile] = useState(null);

    const dispatch = useDispatch();

    const fileUploadRefs = useRef(null);

    const radioOptions = [
        { label: "Accept", value: "Accepted" },
        { label: "Reject", value: "Rejected" }
    ]

    const truncateUrl = (url) => {
        if (!url) return "";
        const start = url.slice(0, 40);
        const end = url.slice(-20);
        return `${start}...${end}`
    }

    const checkValidFile = (file) => {
        const formData = new FormData();
        formData.append("file", file)
        formData.append("fileName", file?.name)
        dispatch(FileValidationAction(formData))
    }

    const handleEntityRadio = ({ target: { value } }) => {
        if (selectedSource?.entityMatchStatus === "Completed" && value !== selectedSource?.isEntityMatched) {
            // setShowMatchedEntity(true);
            setRejectReason((prevVal) => ({
                ...prevVal,
                entity: ""
            }))
        } else {
            // setShowMatchedEntity(false);
            setRejectReason((prevVal) => ({
                ...prevVal,
                entity: selectedSource?.entityReason
            }))
        }

        if (value === "Rejected") setShowFyForm(false);
        if (value === "Accepted") setShowFyForm(true);

        setRadioValues((prevVal) => ({
            ...prevVal,
            entity: value
        }));
        setEntityFormErrors((prevErrors) => ({
            ...prevErrors,
            entityRadioValue: "",
            entityReason: ""
        }));
    }

    const handleYearRadio = (event, variable) => {
        const { target: { value } } = event;
        setRadioValues((prevVal) => ({
            ...prevVal,
            year: { ...prevVal?.year, [variable]: value }
        }))
        setYearFormErrors((prevErrors) => ({
            ...prevErrors,
            yearRadioValue: { ...prevErrors?.yearRadioValue, [variable]: "" },
            yearReason: { ...prevErrors?.yearReason, [variable]: "" }
        }))
    }

    const handlePreview = (fileId, fileName) => {
        dispatch(downloadFailedFilesReset())
        const payload = {
            clientSourceListId: fileId
        }
        dispatch(DownloadFailedFile(payload))
        if (fileName?.endsWith(".pdf") || fileName?.endsWith(".zip")) {
            setShowPDFPreview(true)
        } else {
            setShouldDownload(true);
        }
    }

    const handleFilePreview = (fileId) => {
        dispatch(downloadFailedFilesReset())
        const payload = {
            clientSourceListId: fileId
        }
        dispatch(DownloadFailedFile(payload))
        if (selectedSource?.s3FileName?.endsWith(".pdf") || selectedSource?.s3FileName?.endsWith(".zip")) {
            setShowPDFPreview(true)
        }
    }

    const handleEntityReasonChange = ({ target: { value } }) => {
        setRejectReason((prevVal) => ({
            ...prevVal,
            entity: value
        }))
        setEntityFormErrors((prevErrors) => ({
            ...prevErrors,
            entityReason: ""
        }))
    }

    const handleFyReasonChange = ({ target: { value } }, variable) => {
        setRejectReason((prevVal) => ({
            ...prevVal,
            year: { ...prevVal.year, [variable]: value }
        }))
        setYearFormErrors((prevErrors) => ({
            ...prevErrors,
            yearReason: { ...prevErrors?.yearReason, [variable]: "" }
        }))
    }

    const handleCheckboxChange = ({ target: { checked } }) => {
        setCoverSheet(checked);
        setIsNonEnglish(false);
        setEntityFormErrors({
            entityRadioValue: "",
            entityReason: ""
        })
        setYearFormErrors({
            yearRadioValue: {},
            yearReason: {}
        })
    }

    const handleNonEnglishCheckboxChange = ({ target: { checked } }) => {
        setIsNonEnglish(checked);
        setCoverSheet(false)
        setEntityFormErrors({
            entityRadioValue: "",
            entityReason: ""
        })
        setYearFormErrors({
            yearRadioValue: {},
            yearReason: {}
        })
    }

    const handleFileUpload = () => {
        if (fileUploadRefs.current) {
            fileUploadRefs.current.click();
        }
    };

    const handleFileChange = async (input, event) => {
        const file = event.target.files[0];
        event.target.value = "";
        if (file) {
            const fileType = file.type;
            const fileSizeLimit = 100 * 1024 * 1024; // 100MB
            if (file.size > fileSizeLimit) {
                message.error("File size exceeds 100MB limit");
                return;
            }
            const allowedMimeTypes = [
                'application/pdf',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'application/vnd.ms-excel',
                'text/csv',
                'application/csv',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/msword'
            ];
            if (allowedMimeTypes?.includes(fileType)) {
                checkValidFile(file)
                try {
                    setFile(file);
                } catch (error) {
                    message.error("Error converting file to base64:", error);
                }
            } else {
                message.error(`${file.name} is not a supported file type.`);
            }
        }
    };

    const handleSubmit = () => {
        let entityErrors = {};
        if (!radioValues?.entity?.trim()) {
            entityErrors.entityRadioValue = "Please select entity status";
        }
        if (radioValues?.entity && radioValues?.entity === "Rejected" && !rejectReason?.entity?.trim()) {
            entityErrors.entityReason = "Please enter the reason";
        }
        if (!matchedEntityValue?.trim()) {
            entityErrors.matchedEntity = "Please enter matched entity name";
        }

        const fyRadioErrors = {};
        const fyReasonErrors = {};
        const fyErrorVariables = [];

        if (showFyForm) {
            applicableVariables?.forEach((variable) => {
                const radioValue = radioValues?.year?.[variable]?.trim?.();
                const reasonValue = rejectReason?.year?.[variable]?.trim?.();

                if (!radioValue) {
                    fyRadioErrors[variable] = "Please select fiscal year status";
                    fyErrorVariables.push(variable);
                }

                if (!reasonValue && radioValue && radioValue === "Rejected") {
                    fyReasonErrors[variable] = "Please enter the reason";
                    if (!fyErrorVariables.includes(variable)) fyErrorVariables.push(variable);
                }
            });
        }

        if (!coverSheet && !isNonEnglish) {
            setEntityFormErrors(entityErrors);
            setYearFormErrors({
                yearRadioValue: fyRadioErrors,
                yearReason: fyReasonErrors,
            });
        }

        if (!coverSheet && !isNonEnglish && fyErrorVariables.length > 0) {
            message.error(`FY validations missing for variables: ${fyErrorVariables?.join(", ")}`);
        }

        if ((Object.keys(entityErrors).length === 0 && fyErrorVariables?.length === 0) || (coverSheet || isNonEnglish)) {
            if (selectedSource?.isWebpage && !selectedSource?.s3FileName) {
                setShowReviewSubmissionModal(true)
            } else {
                const fyValidation = radioValues?.entity === "Accepted" ? applicableVariables?.map((variable) => {
                    const radioValue = radioValues?.year?.[variable]?.trim();
                    const reasonValue = rejectReason?.year?.[variable]?.trim();

                    return {
                        variable,
                        isMatched: radioValue,
                        modeOfValidation: "User",
                        reason: reasonValue ? reasonValue : "",
                        status: "Completed"
                    }
                }) : [];

                const isNonStandardDoc = coverSheet || isNonEnglish;
                const acceptFile = radioValues?.entity === "Accepted" && Object.values(radioValues?.year || {})?.some(val => val === "Accepted")

                const payload = {
                    isCoverSheet: coverSheet,
                    isNonEnglishDocument: isNonEnglish,
                    entityStatus: isNonStandardDoc ? "" : (radioValues?.entity ? radioValues?.entity : ""),
                    entityReason: isNonStandardDoc ? "" : (radioValues?.entity ? rejectReason?.entity : ""),
                    matchedEntityName: isNonStandardDoc ? "" : (matchedEntityValue?.trim() || "NA"),
                    evidenceId: selectedSource?.evidenceId,
                    fyValidation: isNonStandardDoc ? [] : fyValidation
                }
                const formData = new FormData();
                if (file && acceptFile) {
                    formData.append("file", file);
                }
                formData.append("payload", JSON.stringify(payload))
                if (isNonStandardDoc || !selectedSource?.s3FileName) {
                    dispatch(CompleteReview(formData))
                } else {
                    setShowDocSubmissionModal({
                        show: true,
                        payload: formData,
                        type: "validate"
                    })
                }
            }
        }
    }

    const handleMatchedEntity = (value) => {
        setMatchedEntityValue(value);
        setEntityFormErrors((prevVal) => ({
            ...prevVal,
            matchedEntity: ""
        }));
    }

    const tableHeader = [
        {
            title: 'Variable',
            dataIndex: 'variable',
            key: 'variable',
            width: '15%',
            sorter: (a, b) => a.variable.localeCompare(b.variable),
        },
        {
            title: 'Notes',
            dataIndex: 'notes',
            key: 'notes',
            width: '55%',
            sorter: (a, b) => a.notes.localeCompare(b.notes),
        },
        {
            title: 'FY Validation',
            dataIndex: 'validationForm',
            key: 'validationForm',
            width: '30%',
            sorter: (a, b) => a.validationForm.localeCompare(b.validationForm),
        },
    ]

    const formattedtableData = (applicableVariables = []) => {

        const formattedData = applicableVariables?.map((variable, index) => {
            return {
                key: index,
                variable: variable,
                notes: (
                    <div className="notes-section">
                        <div className="input-label">Notes</div>
                        <div className="content">{selectedSource.notes[variable]}</div>
                    </div>
                ),
                validationForm: (
                    <div className="year-validation-section">
                        <div className="year-details">
                            <div className="entity-label">Fiscal Year</div>
                        </div>
                        <div className="entity-form-section">
                            <Radio.Group className="entity-radio" options={radioOptions} onChange={(e) => handleYearRadio(e, variable)} value={radioValues?.year[variable]} disabled={coverSheet || isNonEnglish} />
                            {yearFormErrors.yearRadioValue[variable]?.trim() && <div className="error-message">{yearFormErrors.yearRadioValue[variable]}</div>}
                        </div>
                        <div className="entity-form-section">
                            <TextArea className="year-reason" placeholder="Enter the reason..." rows={3} onChange={(e) => handleFyReasonChange(e, variable)} value={rejectReason?.year[variable]} disabled={coverSheet || isNonEnglish} />
                            {yearFormErrors.yearReason[variable]?.trim() && <div className="error-message">{yearFormErrors.yearReason[variable]}</div>}
                        </div>
                    </div>
                )
            }
        });

        return formattedData;
    }

    useEffect(() => {
        if (selectedSource?.isCoverSheet) setCoverSheet(true)
        if (selectedSource?.isNonEnglishDocument) setIsNonEnglish(true)
        if (selectedSource?.isEntityMatched === "Accepted") setShowFyForm(true);
        let fyValues = {};
        let fyReason = {};
        selectedSource?.fyValidation?.forEach((fy) => {
            fyValues = { ...fyValues, [fy?.variable]: fy?.isMatched }
            fyReason = { ...fyReason, [fy?.variable]: fy?.reason }
        })
        setRadioValues({
            entity: selectedSource?.entityMatchStatus === "Completed" ? selectedSource?.isEntityMatched : "",
            year: fyValues
        })
        setRejectReason({
            entity: selectedSource?.entityReason,
            year: fyReason
        })
        setMatchedEntityValue(selectedSource?.entityValidation?.matchedEntityName);
        setApplicableVariables(selectedSource?.variables?.applicableVariables || []);
        if (selectedSource?.nestedDocumentsData) {
            setDocumentList(selectedSource?.nestedDocumentsData)
        }
    }, [selectedSource])

    useEffect(() => {
        if (!showPDFPreview) {
            dispatch(downloadFailedFilesReset());
        }
    }, [showPDFPreview])

    useEffect(() => {
        if (clearTrigger) {
            setFile(null);
            setShowUploadConfirmationModal(false)
            dispatch(fileValidationReset());
        }
    }, [clearTrigger])

    return (
        <div className="validation-modal-contents">
            {selectedSource?.s3FileName && (
                <div className="cover-sheet-section">
                    <Checkbox checked={coverSheet} onChange={handleCheckboxChange}><span className="coversheet-label">Coversheet</span></Checkbox>
                    <Checkbox checked={isNonEnglish} onChange={handleNonEnglishCheckboxChange}><span className="coversheet-label">Non-English</span></Checkbox>
                </div>
            )}
            <div className="upload-identifier-section">
                <div className="identifier-section">
                    <div className="input-label">
                        Identifier
                    </div>
                    <div className={`identifier ${copiedId === selectedSource?.evidenceId ? "copy" : ""}`} onClick={() => handleCopyIdentifier(selectedSource?.evidenceId, setCopiedId)}>
                        {copiedId === selectedSource?.evidenceId ? 'Copied' : 'Copy'} <span><IoMdCopy /></span>
                    </div>
                </div>
                {selectedSource?.s3FileName && (
                    <div className="file-upload-section">
                        <div className="file-upload" onClick={handleFileUpload}>
                            <div className="icon"><FaFileCirclePlus /></div>
                            <div className="add-file">Add File</div>
                        </div>
                        <input
                            ref={fileUploadRefs}
                            type="file"
                            accept=".pdf,.xlsx,.xls,.csv,.docx,.doc"
                            style={{ display: "none" }}
                            onChange={(e) => handleFileChange("file", e)}
                        />
                        {fileValidationLoading ?
                            <Spin size="small" /> :
                            <div className="file-name">{file?.name}
                                {file?.name && <div className="delete" onClick={() => setFile(null)}>
                                    <FaRegTrashAlt />
                                </div>}</div>}
                    </div>
                )}
            </div>
            <div className="file-section">
                {
                    selectedSource?.isWebpage ? (
                        <div className="link" title={selectedSource?.sourceUrl}>
                            <div className="link-label">Link</div>
                            <a className="web-link" href={selectedSource?.sourceUrl} rel="noreferrer" target="_blank">
                                {truncateUrl(selectedSource?.sourceUrl)}
                                <span className="link-icon"><IoOpenOutline /></span>
                            </a>
                        </div>
                    ) : (
                        <div className="file-name-wrapper">
                            <div className="file-label">File</div>
                            <div className="file-name">
                                <span onClick={() => { handleFilePreview(selectedSource.evidenceId) }}>{selectedSource?.s3FileName?.endsWith('.zip') ? `${selectedSource?.s3FileName} / ${selectedSource?.additionalFields?.extractedFileName}` : selectedSource?.s3FileName}</span>
                            </div>
                        </div>
                    )
                }
                {!(selectedSource?.isWebpage && selectedSource?.s3FileName) && (<div className="parent-wrapper">
                    <div className="parent-label">Parent</div>
                    <div className="content">{selectedSource?.variables?.applicableVariables?.join(", ")}</div>
                </div>)}
            </div>
            {
                (selectedSource?.isWebpage && selectedSource?.s3FileName) && (
                    <div className="file-parent-wrapper">
                        <div className="file-name-wrapper">
                            <div className="file-label">File</div>
                            <div className="file-name">
                                <span onClick={() => { handleFilePreview(selectedSource.evidenceId) }}>{selectedSource?.s3FileName}</span>
                            </div>
                        </div>
                        <div className="parent-wrapper">
                            <div className="parent-label">Parent</div>
                            <div className="content">{selectedSource?.variables?.applicableVariables?.join(", ")}</div>
                        </div>
                    </div>
                )
            }
            {radioValues?.entity === "Rejected" &&
                <div className="variable-notes-section">
                    <Table
                        pagination={false}
                        dataSource={Object.entries(selectedSource?.notes || {}).map(([key, value]) => ({
                            key,
                            variable: key,
                            notes: value
                        }))}
                        columns={variableNotesHeader}
                    />
                </div>}
            <div className="reporting-details-wrapper">
                <div className="reporting-start-wrapper">
                    <div className="start-label">Reporting Start Date</div>
                    <div className="content">{selectedSource?.reporting_period_start_date}</div>
                </div>
                <div className="reporting-end-wrapper">
                    <div className="end-label">Reporting End Date</div>
                    <div className="content">{selectedSource?.reporting_period_end_date}</div>
                </div>
            </div>
            <div className="entity-details-wrapper">
                <div className="entity-details-section">
                    <div className="entity-account-wrapper">
                        <div className="entity-label">
                            Entity Account Name
                        </div>
                        <div className="content">{selectedSource?.entity_account_name}</div>
                    </div>
                    <div className="entity-manager-wrapper">
                        <div className="entity-label">Entity Manager</div>
                        <div className="content">{selectedSource?.entity_manager}</div>
                    </div>
                </div>
                <div className="entity-validation-section">
                    <div className="entity-details">
                        <div className="entity-label">Entity Name</div>
                        <div className="content">{selectedSource?.entityName}</div>
                    </div>
                    <div className="entity-form-section">
                        <Radio.Group className="entity-radio" options={radioOptions} onChange={handleEntityRadio} value={radioValues?.entity} disabled={coverSheet || isNonEnglish} />
                        {entityFormErrors.entityRadioValue && <div className="error-message">{entityFormErrors?.entityRadioValue}</div>}
                    </div>
                    {true && (
                        <div className="matched-entity-wrapper">
                            <div className="matched-entity-label">Matched Entity Name <span>*</span></div>
                            <Input placeholder="Enter name" type="text" value={matchedEntityValue} onChange={(e) => handleMatchedEntity(e?.target?.value)} disabled={coverSheet || isNonEnglish} />
                            {entityFormErrors.matchedEntity && <div className="error-message">{entityFormErrors.matchedEntity}</div>}
                        </div>
                    )}
                    <div className="entity-form-section">
                        <div className="entity-label">Reason {radioValues?.entity === "Rejected" && <span>*</span>}</div>
                        <TextArea className="entity-reason" placeholder="Enter the reason..." rows={3} onChange={handleEntityReasonChange} value={rejectReason?.entity} disabled={coverSheet || isNonEnglish} />
                        {entityFormErrors.entityReason && <div className="error-message">{entityFormErrors.entityReason}</div>}
                    </div>
                </div>
            </div>
            {selectedSource?.isWebpage && selectedSource?.nestedDocumentsData?.length > 0 && <div className="document-list-section">
                {documentList?.length > 0 && (
                    <>
                        <div className="document-list-header">Uploaded Documents </div>
                        <NestedDocumentsTable
                            documentList={selectedSource?.nestedDocumentsData}
                            onFilePreview={handlePreview}
                            setDeleteFile={setDeleteFile}
                            setShowDeleteFileModal={setShowDeleteFileModal}
                            copiedId={copiedId}
                            setCopiedId={setCopiedId}
                            showDelete={false}
                        />
                    </>
                )}
            </div>}
            {showFyForm && (
                <div className="variable-wrapper">
                    <Table pagination={false} columns={tableHeader} dataSource={formattedtableData(applicableVariables)} />
                </div>
            )}

            <div className="actions-container">
                <div className="button-wrapper submit" onClick={handleSubmit}>{completeReviewLoading ? <Spin className="submit-loading" indicator={antIcon} /> : "Complete Review"}</div>
                <div className="button-wrapper cancel" onClick={handleClose}>Cancel</div>
            </div>
        </div>
    )
}

const ReviewSubmissionModal = ({ handleClose, radioValues, rejectReason, selectedSource, isLoading }) => {
    const [applicableVariables, setApplicableVariables] = useState([]);

    const dispatch = useDispatch();

    const message = "By confirming, you are submitting this evidence for review and will no longer be able to upload files for it. Do you want to proceed?"

    const handleConfirmSubmission = () => {
        const fyValidation = radioValues?.entity === "Accepted" ? applicableVariables?.map((variable) => {
            const radioValue = radioValues?.year?.[variable]?.trim();
            const reasonValue = rejectReason?.year?.[variable]?.trim();
            return {
                variable,
                isMatched: radioValue,
                modeOfValidation: "User",
                reason: reasonValue,
                status: "Completed"
            }
        }) : [];

        const payload = {
            entityStatus: radioValues?.entity,
            entityReason: radioValues?.entity ? rejectReason?.entity : "",
            evidenceId: selectedSource?.evidenceId,
            fyValidation,
        }
        const formData = new FormData();
        formData.append("payload", JSON.stringify(payload))
        dispatch(CompleteReview(formData))
    }

    useEffect(() => {
        setApplicableVariables(selectedSource?.variables?.applicableVariables || []);
    }, [selectedSource])

    return (
        <div className="review-submission-modal">
            <p className="modal-message">{message}</p>
            <div className="action-buttons">
                <div className="button-wrapper yes" onClick={handleConfirmSubmission}>
                    {isLoading ? <Spin className="yes-loading" indicator={antIcon} /> : "Yes"}
                </div>
                <div className="button-wrapper no" onClick={handleClose}>
                    No
                </div>
            </div>
        </div>
    )
}

const UploadConfirmationModal = ({ handleClose, handleUpload, message }) => {

    return (
        <div className="review-submission-modal">
            <p className="modal-message">{message}</p>
            <div className="action-buttons">
                <div className="button-wrapper yes" onClick={handleClose}>
                    Yes
                </div>
                <div className="button-wrapper no" onClick={handleUpload}>
                    No
                </div>
            </div>
        </div>
    )
}

const DocSubmissionModal = ({ handleClose, message, handleConfirmSubmit, isLoading }) => {
    return (
        <div className="review-submission-modal">
            <p className="modal-message">{message}</p>
            <div className="action-buttons">
                <div className="button-wrapper yes" onClick={handleConfirmSubmit}>
                    {isLoading ? <Spin indicator={antIcon} /> : "Yes"}
                </div>
                <div className="button-wrapper no" onClick={handleClose}>
                    No
                </div>
            </div>
        </div>
    )
}

const ViewDetailsModal = ({ selectedSource, setShouldDownload, setShowDeleteFileModal, setShowDocSubmissionModal, setDeleteFile, updateDocsLoading, updateDocsFormDataLoading, documentList, setDocumentList, clearTrigger, setShowUploadConfirmationModal, setShowPDFPreview, handleClose, fileValidationLoading, copiedId, setCopiedId }) => {

    const [isEditModeEnabled, setIsEditModeEnabled] = useState(false);
    const [indexId, setIndexId] = useState(0)
    const [linkStatus, setLinkStatus] = useState(null);
    const [matchedEntityValue, setMatchedEntityValue] = useState("");
    const [entityFormErrors, setEntityFormErrors] = useState({
        entityRadioValue: "",
        entityReason: "",
        linkReason: "",
        matchedEntity: ""
    });
    const [linkReason, setLinkReason] = useState(null);
    const [coverSheet, setCoverSheet] = useState(false);
    const [isNonEnglish, setIsNonEnglish] = useState(false);
    const [yearFormErrors, setYearFormErrors] = useState({
        yearRadioValue: {},
        yearReason: {}
    });
    const [radioValues, setRadioValues] = useState({ entity: "", year: {} });
    const [urlFields, setUrlFields] = useState([]);
    const [showFyForm, setShowFyForm] = useState(false);
    const [rejectReason, setRejectReason] = useState({ entity: "", year: {} });
    const [applicableVariables, setApplicableVariables] = useState([]);

    const dispatch = useDispatch();

    const fileUploadRefs = useRef([]);

    const linkStatusOptions = [
        { label: "Valid", value: "Valid" },
        { label: "Invalid", value: "Invalid" },
    ]

    const disableFileUpload = !isEditModeEnabled ||
        coverSheet ||
        isNonEnglish ||
        radioValues?.entity === "Rejected" ||
        (radioValues?.entity === "Accepted" && Object.values(radioValues?.year || {})?.some(val => val === "Rejected")) ||
        linkStatus === "Invalid"

    const tableHeader = [
        {
            title: 'Variable',
            dataIndex: 'variable',
            key: 'variable',
            width: '15%',
            sorter: (a, b) => a.variable.localeCompare(b.variable),
        },
        {
            title: 'Notes',
            dataIndex: 'notes',
            key: 'notes',
            width: '55%',
            sorter: (a, b) => a.notes.localeCompare(b.notes),
        },
        {
            title: 'FY Validation',
            dataIndex: 'validationForm',
            key: 'validationForm',
            width: '30%',
            sorter: (a, b) => a.validationForm.localeCompare(b.validationForm),
        },
    ]

    const radioOptions = [
        { label: "Accept", value: "Accepted" },
        { label: "Reject", value: "Rejected" }
    ]

    const formattedtableData = (tableData = []) => {
        const formattedData = tableData.map((item, index) => {
            const variableName = typeof item === "string" ? item : item.variable;
            return {
                key: index,
                variable: variableName,
                notes: (
                    <div className="notes-section">
                        <div className="content">{selectedSource?.notes?.[variableName]}</div>
                    </div>
                ),
                validationForm: (
                    <div className="year-validation-section">
                        <div className="year-details">
                            <div className="entity-label">Fiscal Year</div>
                        </div>
                        <div className="entity-form-section">
                            <Radio.Group
                                className="entity-radio"
                                options={radioOptions}
                                onChange={(e) => handleYearRadio(e, { variable: variableName })}
                                value={radioValues?.year?.[variableName]}
                                disabled={!isEditModeEnabled || coverSheet || isNonEnglish}
                            />
                            {yearFormErrors?.yearRadioValue?.[variableName]?.trim() && (
                                <div className="error-message">
                                    {yearFormErrors.yearRadioValue[variableName]}
                                </div>
                            )}
                        </div>
                        <div className="entity-form-section">
                            <TextArea
                                className="year-reason"
                                placeholder="Enter the reason..."
                                rows={3}
                                onChange={(e) => handleFyReasonChange(e, { variable: variableName })}
                                value={rejectReason?.year?.[variableName]}
                                disabled={!isEditModeEnabled || coverSheet || isNonEnglish}
                            />
                            {yearFormErrors?.yearReason?.[variableName]?.trim() && (
                                <div className="error-message">
                                    {yearFormErrors.yearReason[variableName]}
                                </div>
                            )}
                        </div>
                    </div>
                )
            };
        });

        return formattedData;
    };


    const handlePreview = (fileId, fileName) => {
        dispatch(downloadFailedFilesReset())
        const payload = {
            clientSourceListId: fileId
        }
        dispatch(DownloadFailedFile(payload))
        if (fileName?.endsWith(".pdf") || fileName?.endsWith(".zip")) {
            setShowPDFPreview(true)
        } else {
            setShouldDownload(true)
        }
    }

    const handleFilePreview = (fileId) => {
        dispatch(downloadFailedFilesReset())
        const payload = {
            clientSourceListId: fileId
        }
        dispatch(DownloadFailedFile(payload))
        setShowPDFPreview(true)
    }

    const handleEntityRadio = ({ target: { value } }) => {
        if (selectedSource?.entityMatchStatus === "Completed" && value !== selectedSource?.isEntityMatched) {
            // setShowMatchedEntity(true);
            setRejectReason((prevVal) => ({
                ...prevVal,
                entity: ""
            }))
        } else {
            // setShowMatchedEntity(false);
            setRejectReason((prevVal) => ({
                ...prevVal,
                entity: selectedSource?.entityReason
            }))
        }

        if (value === "Rejected") setShowFyForm(false);
        if (value === "Accepted") setShowFyForm(true);

        setRadioValues((prevVal) => ({
            ...prevVal,
            entity: value
        }));
        setEntityFormErrors((prevErrors) => ({
            ...prevErrors,
            entityRadioValue: "",
            entityReason: ""
        }));
    }

    const handleYearRadio = (event, variable) => {
        const { target: { value } } = event;
        setRadioValues((prevVal) => ({
            ...prevVal,
            year: { ...prevVal?.year, [variable.variable]: value }
        }))
        setYearFormErrors((prevErrors) => ({
            ...prevErrors,
            yearRadioValue: { ...prevErrors?.yearRadioValue, [variable.variable]: "" },
            yearReason: { ...prevErrors?.yearReason, [variable.variable]: "" }
        }))
    }

    const handleEntityReasonChange = ({ target: { value } }) => {
        setRejectReason((prevVal) => ({
            ...prevVal,
            entity: value
        }))
        setEntityFormErrors((prevErrors) => ({
            ...prevErrors,
            entityReason: ""
        }))
    }

    const handleFyReasonChange = ({ target: { value } }, variable) => {
        setRejectReason((prevVal) => ({
            ...prevVal,
            year: { ...prevVal.year, [variable.variable]: value }
        }))
        setYearFormErrors((prevErrors) => ({
            ...prevErrors,
            yearReason: { ...prevErrors?.yearReason, [variable.variable]: "" }
        }))
    }

    const checkValidFile = (file) => {
        const formData = new FormData();
        formData.append("file", file)
        formData.append("fileName", file?.name)
        dispatch(FileValidationAction(formData))
    }

    const handleFieldChange = (index, field, value) => {
        const updatedFields = [...urlFields];
        updatedFields[index][field] = value;
        setUrlFields(updatedFields);
    };

    const handleUpdate = () => {
        const isNonStandardDoc = coverSheet || isNonEnglish;
        const isWebpage = selectedSource?.isWebpage;
        const evidenceId = selectedSource?.evidenceId;

        const validateEntity = () => {
            const errors = {};
            if (!radioValues?.entity?.trim()) {
                errors.entityRadioValue = "Please select entity status";
            }
            if (radioValues?.entity === "Rejected" && !rejectReason?.entity?.trim()) {
                errors.entityReason = "Please enter the reason";
            }
            if (!matchedEntityValue?.trim()) {
                errors.matchedEntity = "Please enter matched entity name";
            }
            return errors;
        };

        const validateFY = () => {
            const fyRadioErrors = {};
            const fyReasonErrors = {};
            const fyErrorVariables = [];

            if (showFyForm) {
                applicableVariables?.forEach((variable) => {
                    const radioValue = radioValues?.year?.[variable]?.trim?.();
                    const reasonValue = rejectReason?.year?.[variable]?.trim?.();

                    if (!radioValue) {
                        fyRadioErrors[variable] = "Please select fiscal year status";
                        fyErrorVariables.push(variable);
                    }
                    if (radioValue === "Rejected" && !reasonValue) {
                        fyReasonErrors[variable] = "Please enter the reason";
                        if (!fyErrorVariables.includes(variable)) fyErrorVariables.push(variable);
                    }
                });
            }

            return { fyRadioErrors, fyReasonErrors, fyErrorVariables };
        };

        const buildFYValidation = () => {
            return applicableVariables?.map((variable) => ({
                variable,
                isMatched: radioValues?.year?.[variable]?.trim(),
                modeOfValidation: "User",
                reason: rejectReason?.year?.[variable]?.trim() || "",
                status: "Completed"
            })) || [];
        };

        const dispatchStandardPayload = () => {
            const { fyRadioErrors, fyReasonErrors, fyErrorVariables } = validateFY();
            const entityErrors = validateEntity();

            if (!isNonStandardDoc) {
                setEntityFormErrors(entityErrors);
                setYearFormErrors({ yearRadioValue: fyRadioErrors, yearReason: fyReasonErrors });
            }

            if (!isNonStandardDoc && fyErrorVariables.length > 0) {
                message.error(`FY validations missing for variables: ${fyErrorVariables.join(", ")}`);
            }

            const isValid = Object.keys(entityErrors).length === 0 && fyErrorVariables.length === 0;

            if (isValid || isNonStandardDoc) {
                const payload = {
                    sourceformat: "File",
                    isCoverSheet: coverSheet,
                    isNonEnglishDocument: isNonEnglish,
                    entityStatus: isNonStandardDoc ? "" : (radioValues?.entity || ""),
                    entityReason: isNonStandardDoc ? "" : (rejectReason?.entity || ""),
                    matchedEntityName: isNonStandardDoc ? "" : (matchedEntityValue?.trim() || "NA"),
                    clientSourceListId: evidenceId,
                    fyValidation: isNonStandardDoc || radioValues?.entity !== "Accepted" ? [] : buildFYValidation()
                };
                if (disableFileUpload || urlFields?.length === 0) {
                    setShowDocSubmissionModal({
                        show: true,
                        payload: JSON.stringify(payload),
                        type: "Non-FormData Review"
                    })
                } else {
                    const formData = new FormData();
                    const mimeType = getMimeTypeFromExtension(urlFields[0].fileName);
                    const blob = base64ToBlob(urlFields[0].base64, mimeType);
                    const file = new File([blob], urlFields[0].fileName, { type: mimeType });
                    formData.append("files", file);
                    formData.append("payload", JSON.stringify(payload));
                    setShowDocSubmissionModal({
                        show: true,
                        payload: formData,
                        type: "Review"
                    })
                }
            }
        };

        const dispatchWebLinkInvalid = () => {
            if (!linkReason?.trim()) {
                setEntityFormErrors((prev) => ({ ...prev, linkReason: "Please enter the reason for invalid link" }));
                return false;
            }
            const payload = {
                sourceformat: "Webpage",
                clientSourceListId: evidenceId,
                isValidUrl: false,
                reason: linkReason
            }
            dispatch(UpdateDocsData({ payload: JSON.stringify(payload) }));
            return true;
        };

        const dispatchWebWithUpload = () => {
            const { fyRadioErrors, fyReasonErrors, fyErrorVariables } = validateFY();
            const entityErrors = validateEntity();
            setEntityFormErrors(entityErrors);
            setYearFormErrors({ yearRadioValue: fyRadioErrors, yearReason: fyReasonErrors });
            if (Object.keys(entityErrors).length > 0) {
                return;
            }
            if (fyErrorVariables.length > 0) {
                message.error(`FY validations missing for variables: ${fyErrorVariables.join(", ")}`);
                return;
            }
            if (!selectedSource?.s3FileName && urlFields && urlFields?.length > 0 && urlFields.some((f) => !f.fileUrl || !f.sectionUrl || !f.fileName)) {
                message.error("Please fill all the fields/upload a file before submitting");
                return;
            }
            const formData = new FormData();
            const fileDetails = [];

            (!selectedSource?.s3FileName && urlFields && urlFields?.length > 0) && urlFields.forEach((f, index) => {
                const mimeType = getMimeTypeFromExtension(f?.fileName);
                const blob = base64ToBlob(f.base64, mimeType);
                const file = new File([blob], f.fileName, { type: mimeType });
                formData.append("files", file);

                fileDetails.push({
                    index,
                    fileUrl: f.fileUrl,
                    sectionUrl: f.sectionUrl
                });
            });
            if (!selectedSource?.s3FileName) {
                const payload = {
                    sourceformat: "Webpage",
                    isValidUrl: true,
                    entityStatus: radioValues?.entity || "",
                    entityReason: rejectReason?.entity || "",
                    matchedEntityName: matchedEntityValue?.trim() || "NA",
                    clientSourceListId: evidenceId,
                    fyValidation: radioValues?.entity !== "Accepted" ? [] : buildFYValidation(),
                    fileDetails
                };

                formData.append("payload", JSON.stringify(payload));
                dispatch(UpdateDocsFormData(formData));
            } else {
                const payload = {
                    sourceformat: "Webpage",
                    isValidUrl: true,
                    entityStatus: radioValues?.entity || "",
                    entityReason: rejectReason?.entity || "",
                    matchedEntityName: matchedEntityValue?.trim() || "NA",
                    clientSourceListId: evidenceId,
                    fyValidation: radioValues?.entity !== "Accepted" ? [] : buildFYValidation(),
                }
                if (disableFileUpload || urlFields?.length === 0) {
                    setShowDocSubmissionModal({
                        show: true,
                        payload: JSON.stringify(payload),
                        type: "Non-FormData Review"
                    })
                } else {
                    const formData = new FormData();
                    const mimeType = getMimeTypeFromExtension(urlFields[0]?.fileName);
                    const blob = base64ToBlob(urlFields[0].base64, mimeType);
                    const file = new File([blob], urlFields[0].fileName, { type: mimeType });
                    formData.append("files", file);
                    formData.append("payload", JSON.stringify(payload));
                    setShowDocSubmissionModal({
                        show: true,
                        payload: formData,
                        type: "Review"
                    })
                }
            }
        };

        if (isNonStandardDoc) {
            const payload = {
                sourceformat: selectedSource?.isWebpage ? "Webpage" : "File",
                isCoverSheet: coverSheet,
                isNonEnglishDocument: isNonEnglish,
                clientSourceListId: evidenceId
            }
            dispatch(UpdateDocsData({ payload: JSON.stringify(payload) }));
        } else if (isWebpage) {
            linkStatus === "Invalid" ? dispatchWebLinkInvalid() : dispatchWebWithUpload();
        } else {
            dispatchStandardPayload();
        }
    };


    const handleAddField = () => {
        if (urlFields.length >= 10) {
            message.error("Maximum Limit Reached")
            return;
        } else {
            setUrlFields([...urlFields, { fileUrl: "", sectionUrl: "" }]);
        }
    }

    const handleDelete = (field, index) => {
        const updatedFields = urlFields.filter((_, i) => i !== index);
        fileUploadRefs.current.splice(index, 1);
        setUrlFields(updatedFields)
    }

    const handleFileUpload = (index) => {
        setIndexId(index)
        if (fileUploadRefs.current[index]) {
            fileUploadRefs.current[index].click();
        }
    };

    const handleClear = (index, file, base64) => {
        const updatedFields = [...urlFields];
        updatedFields[index][file] = "";
        updatedFields[index][base64] = "";
        setUrlFields(updatedFields);
    }

    const handleLinkStatusChange = (e) => {
        setLinkStatus(e)
        setEntityFormErrors({
            entityRadioValue: "",
            entityReason: "",
            linkReason: "",
            matchedEntity: ""
        })
        setYearFormErrors({
            yearRadioValue: {},
            yearReason: {}
        })
    }

    const handleFileChange = async (index, field, input, event) => {
        const file = event.target.files[0];
        event.target.value = "";
        if (file) {
            const fileType = file.type;
            const fileSizeLimit = 100 * 1024 * 1024; // 100MB
            if (file.size > fileSizeLimit) {
                message.error("File size exceeds 100MB limit");
                return;
            }
            const allowedMimeTypes = [
                'application/pdf',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'application/vnd.ms-excel',
                'text/csv',
                'application/csv',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/msword'
            ];
            if (allowedMimeTypes?.includes(fileType)) {
                checkValidFile(file)
                const updatedFields = [...urlFields];
                if (!updatedFields[index]) {
                    updatedFields[index] = {};
                }
                updatedFields[index][field] = file.name;
                setUrlFields(updatedFields);

                try {
                    const base64 = await getBase64(file);
                    const updatedFieldsWithBase64 = [...updatedFields];
                    updatedFieldsWithBase64[index][input] = base64.split(";base64,")[1];
                    setUrlFields(updatedFieldsWithBase64);
                } catch (error) {
                    message.error("Error converting file to base64:", error);
                }
            } else {
                message.error(`${file.name} is not a supported file type.`);
            }
        }
    };

    const handleCheckboxChange = ({ target: { checked } }) => {
        setCoverSheet(checked);
        setIsNonEnglish(false);
        setEntityFormErrors({
            entityRadioValue: "",
            entityReason: ""
        })
        setYearFormErrors({
            yearRadioValue: {},
            yearReason: {}
        })
    }

    const handleNonEnglishCheckboxChange = ({ target: { checked } }) => {
        setIsNonEnglish(checked);
        setCoverSheet(false)
        setEntityFormErrors({
            entityRadioValue: "",
            entityReason: ""
        })
        setYearFormErrors({
            yearRadioValue: {},
            yearReason: {}
        })
    }

    const handleMatchedEntity = (value) => {
        setMatchedEntityValue(value);
        setEntityFormErrors((prevVal) => ({
            ...prevVal,
            matchedEntity: ""
        }));
    }

    const handleInvalidLinkReason = ({ target: { value } }) => {
        setLinkReason(value)
        setEntityFormErrors((prevVal) => ({
            ...prevVal,
            linkReason: ""
        }))
    }

    const handleEdit = () => {
        setIsEditModeEnabled(true)
    }

    const handleFileDelete = (fileName, index) => {
        const updatedFields = [...urlFields];
        if (!updatedFields[index]) updatedFields[index] = {};
        updatedFields[index][fileName] = "";
        updatedFields[index].base64 = "";
        setUrlFields(updatedFields);
    }

    const handleCancel = () => {
        setIsEditModeEnabled(false)
        setEntityFormErrors({
            entityRadioValue: "",
            entityReason: "",
            linkReason: ""
        })
        setYearFormErrors({
            yearRadioValue: {},
            yearReason: {}
        })
    }

    useEffect(() => {
        if (selectedSource?.isWebpage) {
            setLinkStatus(selectedSource?.urlStatus ? "Valid" : "Invalid");
        }
        setLinkReason(selectedSource?.userReason || null);
        if (selectedSource?.isEntityMatched === "Accepted") setShowFyForm(true);
        if (selectedSource?.isCoverSheet) setCoverSheet(true)
        if (selectedSource?.isNonEnglishDocument) setIsNonEnglish(true)
        if (!selectedSource?.isEntityMatched?.trim()) setShowFyForm(true);
        let fyValues = {};
        let fyReason = {};
        selectedSource?.fyValidation?.forEach((fy) => {
            fyValues[fy?.variable] = fy?.isMatched;
            fyReason[fy?.variable] = fy?.reason;
        });
        setRadioValues({
            entity: selectedSource?.isEntityMatched,
            year: fyValues
        })
        setRejectReason({
            entity: selectedSource?.entityReason,
            year: fyReason
        })
        setMatchedEntityValue(selectedSource?.entityValidation?.matchedEntityName);
        setApplicableVariables(selectedSource?.variables?.applicableVariables || []);
        if (selectedSource?.nestedDocumentsData) {
            setDocumentList(selectedSource?.nestedDocumentsData)
        }
    }, [selectedSource])

    useEffect(() => {
        if (clearTrigger) {
            handleClear(indexId, "fileName", "base64")
            setShowUploadConfirmationModal(false)
            dispatch(fileValidationReset());
        }
    }, [clearTrigger])

    return (
        <div className="view-details-modal-container">
            <div className="error-text"><span className="message">Message:</span> {selectedSource?.uploadStatusMessage}</div>
            {selectedSource?.s3FileName && (
                <div className="cover-sheet-section">
                    <Checkbox disabled={!isEditModeEnabled} onChange={handleCheckboxChange} checked={coverSheet}><span className="coversheet-label">Coversheet</span></Checkbox>
                    <Checkbox disabled={!isEditModeEnabled} onChange={handleNonEnglishCheckboxChange} checked={isNonEnglish}><span className="coversheet-label">Non-English</span></Checkbox>
                </div>
            )}
            <div className="upload-identifier-section">
                <div className="identifier-section">
                    <div className="input-label">
                        Identifier
                    </div>
                    <div className={`identifier ${copiedId === selectedSource?.evidenceId ? "copy" : ""}`} onClick={() => handleCopyIdentifier(selectedSource?.evidenceId, setCopiedId)}>
                        {copiedId === selectedSource?.evidenceId ? 'Copied' : 'Copy'} <span><IoMdCopy /></span>
                    </div>
                </div>
                {selectedSource?.s3FileName && (!linkStatus || linkStatus === "Valid") && (
                    <div className="file-upload-section">
                        <div className={`file-upload ${disableFileUpload ? "disabled" : ""}`} onClick={() => handleFileUpload(indexId)}>
                            <div className="icon"><FaFileCirclePlus /></div>
                            <div className="add-file">Add File</div>
                        </div>
                        <input
                            disabled={disableFileUpload}
                            ref={(el) => (fileUploadRefs.current[indexId] = el)}
                            type="file"
                            accept=".pdf,.xlsx,.xls,.csv,.docx,.doc"
                            style={{ display: "none" }}
                            onChange={(e) => handleFileChange(indexId, "fileName", "base64", e)}
                        />
                        {fileValidationLoading ?
                            <Spin size="small" /> :
                            <div className="file-name">{urlFields[0]?.fileName}
                                {urlFields[0]?.fileName && <div className="delete" onClick={() => handleFileDelete("fileName", indexId)}>
                                    <FaRegTrashAlt />
                                </div>}</div>}
                    </div>
                )}
            </div>
            <div className="file-section">
                {
                    selectedSource?.isWebpage ? (
                        <div className="link">
                            <div className="link-label">Section Url</div>
                            <a className="web-link" href={selectedSource?.sourceUrl} title={selectedSource?.sourceUrl} rel="noreferrer" target="_blank">
                                {truncateUrl(selectedSource?.sourceUrl)}
                                <span className="link-icon"><IoOpenOutline /></span>
                            </a>
                        </div>
                    ) : (
                        <div className="file-name-wrapper">
                            <div className="file-label">File</div>
                            <div className="file-name" onClick={() => { handleFilePreview(selectedSource.evidenceId) }}>{selectedSource?.s3FileName?.endsWith('.zip') ? `${selectedSource?.s3FileName} / ${selectedSource?.additionalFields?.extractedFileName}` : selectedSource?.s3FileName}
                            </div>
                        </div>
                    )
                }
                {!(selectedSource?.isWebpage && selectedSource?.s3FileName) && (<div className="parent-wrapper">
                    <div className="parent-label">Parent</div>
                    <div className="content">{selectedSource?.variables?.applicableVariables?.join(", ")}</div>
                </div>)}
            </div>
            {
                (selectedSource?.isWebpage && selectedSource?.s3FileName) && (
                    <div className="file-parent-wrapper">
                        <div className="file-name-wrapper">
                            <div className="file-label">File</div>
                            <div className="file-name">
                                <span onClick={() => { handleFilePreview(selectedSource.evidenceId) }}>{selectedSource?.s3FileName}</span>
                            </div>
                        </div>
                        <div className="parent-wrapper">
                            <div className="parent-label">Parent</div>
                            <div className="content">{selectedSource?.variables?.applicableVariables?.join(", ")}</div>
                        </div>
                    </div>
                )
            }
            <div className="entity-details-section">
                <div className="entity-account-wrapper">
                    <div className="entity-label">
                        Entity Account Name
                    </div>
                    <div className="content">{selectedSource?.entity_account_name}</div>
                </div>
                <div className="entity-manager-wrapper">
                    <div className="entity-label">Entity Manager</div>
                    <div className="content">{selectedSource?.entity_manager}</div>
                </div>
            </div>
            <div className="reporting-details-wrapper">
                <div className="reporting-start-wrapper">
                    <div className="start-label">Reporting Start Date</div>
                    <div className="content">{selectedSource?.reporting_period_start_date}</div>
                </div>
                <div className="reporting-end-wrapper">
                    <div className="end-label">Reporting End Date</div>
                    <div className="content">{selectedSource?.reporting_period_end_date}</div>
                </div>
            </div>
            {(radioValues?.entity === "Rejected" || coverSheet || isNonEnglish) &&
                <div className="variable-notes-section">
                    <Table
                        pagination={false}
                        dataSource={Object.entries(selectedSource?.notes || {}).map(([key, value]) => ({
                            key,
                            variable: key,
                            notes: value
                        }))}
                        columns={variableNotesHeader}
                    />
                </div>}
            <div className="entity-select-wrapper">
                {(!selectedSource?.isWebpage || linkStatus === "Valid") && <div className="matched-entity-wrapper">
                    <div className="matched-entity-label">Matched Entity Name<span>*</span></div>
                    <Input placeholder="Enter name" type="text" className="matched-entity-content" value={matchedEntityValue} disabled={!isEditModeEnabled || coverSheet || isNonEnglish}
                        onChange={(e) => handleMatchedEntity(e?.target?.value)}
                    />
                    {entityFormErrors.matchedEntity && <div className="error-message">{entityFormErrors.matchedEntity}</div>}
                </div>}
                {selectedSource?.isWebpage && <div className="input-wrapper">
                    <div className="input-label">
                        Link Status
                    </div>
                    <div className="input-container">
                        <Select
                            showSearch
                            disabled={!isEditModeEnabled || coverSheet || isNonEnglish}
                            className="filter-select"
                            options={linkStatusOptions}
                            onChange={handleLinkStatusChange}
                            value={linkStatus}
                            placeholder="Select Status"
                            filterOption={(input, option) => option?.label?.toLowerCase()?.includes(input?.toLowerCase())}
                        />
                    </div>
                </div>}
            </div>
            {(!selectedSource?.isWebpage || linkStatus === "Valid") && <div className="entity-form-section">
                <Radio.Group className="entity-radio" options={radioOptions} onChange={handleEntityRadio} value={radioValues?.entity} disabled={!isEditModeEnabled || coverSheet || isNonEnglish} />
                {entityFormErrors.entityRadioValue && <div className="error-message">{entityFormErrors?.entityRadioValue}</div>}
            </div>}
            <div className="entity-form-section">
                <div className="entity-label">Reason{(radioValues?.entity === "Rejected" || linkStatus === "Invalid") && <span>*</span>} </div>
                <TextArea className="entity-reason" placeholder="Enter the reason..." rows={3} onChange={radioValues?.entity === "Rejected" ? handleEntityReasonChange : handleInvalidLinkReason} value={radioValues?.entity === "Rejected" ? rejectReason?.entity : linkReason} disabled={!isEditModeEnabled || coverSheet || isNonEnglish} />
                {entityFormErrors.entityReason && <div className="error-message">{entityFormErrors.entityReason}</div>}
                {entityFormErrors.linkReason && <div className="error-message">{entityFormErrors.linkReason}</div>}
            </div>
            {(selectedSource?.isWebpage && !selectedSource?.s3FileName && linkStatus === "Valid") && <div className="document-list-section">
                <div className="document-list-header">Uploaded Files</div>
                <NestedDocumentsTable
                    documentList={selectedSource?.nestedDocumentsData}
                    onFilePreview={handlePreview}
                    setDeleteFile={setDeleteFile}
                    setShowDeleteFileModal={setShowDeleteFileModal}
                    copiedId={copiedId}
                    setCopiedId={setCopiedId}
                    showDelete={isEditModeEnabled ? true : false}
                />
            </div>}
            {(selectedSource?.isWebpage && !selectedSource?.s3FileName && isEditModeEnabled && linkStatus === "Valid") && <div className="upload-section">
                <>
                    {urlFields?.map((field, index) => (
                        <div key={index} className="file-upload-section">
                            <div className="url-fields-wrapper">
                                <div className="section-url">
                                    <div className="input-label">
                                        Section URL <span>*</span>
                                    </div>
                                    <TextArea
                                        rows={2}
                                        value={field.sectionUrl}
                                        placeholder="Enter url"
                                        onChange={(e) =>
                                            handleFieldChange(index, "sectionUrl", e.target.value)
                                        }
                                    />
                                </div>
                                <div className="source-url">
                                    <div className="input-label">
                                        File URL <span>*</span>
                                    </div>
                                    <TextArea
                                        rows={2}
                                        value={field.fileUrl}
                                        placeholder="Enter url"
                                        onChange={(e) =>
                                            handleFieldChange(index, "fileUrl", e.target.value)
                                        }
                                    />
                                </div>
                                <div className="row-delete" onClick={() => handleDelete(field, index)}>
                                    <FaRegTrashAlt />
                                </div>
                            </div>
                            <div className="file-upload-wrapper">
                                <div className="file-upload" title="upload" onClick={() => handleFileUpload(index)}>
                                    <ImFolderUpload />
                                </div>
                                <input
                                    ref={(el) => (fileUploadRefs.current[index] = el)}
                                    type="file"
                                    accept=".pdf,.xlsx,.xls,.csv,.docx,.doc"
                                    style={{ display: "none" }}
                                    onChange={(e) => handleFileChange(index, "fileName", "base64", e)}
                                />
                                {(fileValidationLoading && (indexId === index)) ? (
                                    <Spin size="small" />
                                ) : (field.fileName && (
                                    <div className="file-name-wrapper">
                                        <div className="file-name" title={field.fileName}>
                                            {field.fileName}
                                            <span className="clear-button" onClick={() => handleClear(index, "fileName", "base64")}>
                                                <FaXmark />
                                            </span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </>
                {radioValues?.entity !== "Rejected" && <div className="add-button-wrapper" onClick={handleAddField}>Add</div>}
            </div>}
            {radioValues?.entity === "Accepted" && (!selectedSource?.isWebpage || linkStatus === "Valid") && <div className="variable-wrapper">
                <Table
                    pagination={false}
                    columns={tableHeader}
                    dataSource={formattedtableData(selectedSource?.fyValidation?.length === 0 ? selectedSource?.variables?.applicableVariables : selectedSource?.fyValidation)}
                />
            </div>}
            <div className="action-container">
                {!isEditModeEnabled && <div className="button-wrapper edit" onClick={handleEdit}>Edit</div>}
                {isEditModeEnabled && (
                    <div className="update-icons-container">
                        <div className={`button-wrapper update ${(updateDocsLoading || updateDocsFormDataLoading) ? "loading" : ""}`} onClick={handleUpdate}>{(updateDocsLoading || updateDocsFormDataLoading) ? <Spin indicator={antIcon} /> : "Update"}</div>
                        <div className="button-wrapper cancel" onClick={handleCancel}>Cancel</div>
                    </div>
                )}
            </div>
        </div>
    )
}

const TruncatingVariableList = ({ variables }) => {
    const variableCount = variables?.length;
    if (variableCount <= 2) {
        return <span>{variables.join(', ')}</span>;
    }

    const tooltipContent = variables?.join(', ');
    const previewText = variables.slice(0, 2).join(', ') + ', ...';
    return (
        <Tooltip title={tooltipContent} placement="topLeft">
            <span style={{ cursor: 'pointer' }}>
                {previewText}
            </span>
        </Tooltip>
    );
};

const ReviewEntities = () => {

    const [showFilters, setShowFilters] = useState(true)
    const [selectedEntity, setSelectedEntity] = useState([])
    const [status, setStatus] = useState(null)
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(200)
    const [formattedTableData, setFormattedTableData] = useState({ dataSource: [], columns: [] })
    const [showPDFPreview, setShowPDFPreview] = useState(false);
    const [selectedObject, setSelectedObject] = useState(null)
    const [showValidateModal, setShowValidateModal] = useState(false)
    const [showWebpageReviewModal, setShowWebpageReviewModal] = useState(false)
    const [showReviewSubmissionModal, setShowReviewSubmissionModal] = useState(false)
    const [showViewDetailsModal, setShowViewDetailsModal] = useState(false)
    const [selectedFormat, setSelectedFormat] = useState(null)
    const [selectedEntityStatus, setSelectedEntityStatus] = useState(null)
    const [selectedFyStatus, setSelectedFyStatus] = useState(null)
    const [reviewStatus, setReviewStatus] = useState(null)
    const [selectedAssessmentType, setSelectedAssessmentType] = useState(null)
    const [radioValues, setRadioValues] = useState({ entity: "", year: {} });
    const [rejectReason, setRejectReason] = useState({ entity: "", year: {} });
    const [documentList, setDocumentList] = useState([])
    const [selectedVariables, setSelectedVariables] = useState([])
    const [variableInitialized, setVariableInitialized] = useState(false);
    const [fileStatus, setFileStatus] = useState("Convertible")
    const [linkStatus, setLinkStatus] = useState("Valid");
    const [showDeleteFileModal, setShowDeleteFileModal] = useState(false)
    const [deleteFile, setDeleteFile] = useState(null)
    const [showUploadConfirmationModal, setShowUploadConfirmationModal] = useState(false)
    const [showDocSubmissionModal, setShowDocSubmissionModal] = useState({
        show: false,
        payload: null,
        type: ""
    })
    const [clearTrigger, setClearTrigger] = useState(false);
    const [copiedId, setCopiedId] = useState(null);
    const [selectedDocument, setSelectedDocument] = useState([]);
    const [shouldDownload, setShouldDownload] = useState(false);

    const dispatch = useDispatch();

    const { data: entityDropdownData, isLoading: entityLoading } = useSelector((state) => state?.entityList)
    const { data: entityListData, isLoading: entityListLoading } = useSelector((state) => state?.entityFilesList) || {}
    const { data: fileSubmitData, isLoading: fileSubmitLoading, success: fileSubmitSuccess, error: fileSubmitError } = useSelector((state) => state.reviewFile) || {}
    const { data: completeReviewData, isLoading: completeReviewLoading, success: completeReviewSuccess, error: completeReviewError } = useSelector((state) => state.completeReview) || {}
    const { data: deleteFileData, isLoading: deleteFileLoading, success: deleteFileSuccess, error: deleteFileError } = useSelector((state) => state.deleteUploadedFile) || {}
    const { data: fileValidationData, isLoading: fileValidationLoading, success: fileValidationSuccess, error: fileValidationError } = useSelector((state) => state?.fileValidation) || {}
    const { data: updateDocsData, isLoading: updateDocsLoading, success: updateDocsSuccess, error: updateDocsError } = useSelector((state) => state?.updateDocsData) || {}
    const { data: updateDocsFormData, isLoading: updateDocsFormDataLoading, success: updateDocsFormDataSuccess, error: updateDocsFormDataError } = useSelector((state) => state?.updateDocsFormData) || {}
    const { isLoading: exportDocReviewLoading, error: exportDocReviewError } = useSelector((state) => state?.docReviewExport) || {}
    const { data: failedFile } = useSelector((state) => state.downloadFailedFile) || {}
    const { entity, variable } = useSelector((state) => state.filterValue) || {};

    const statusOptions = [
        { label: "Success", value: "success" },
        { label: "Failed", value: "failed" }
    ]

    const formatOptions = [
        { label: "File", value: "file" },
        { label: "Webpage", value: "webpage" }
    ]

    const assessmentTypeOptions = [
        { label: "Asset", value: "Asset" },
        { label: "Fund", value: "Fund" },
        { label: "Real-Estate", value: "GRESB Real Estate" },
    ]

    const fileReviewOptions = [
        { label: "Pending", value: "Pending" },
        { label: "Reviewed", value: "Reviewed" }
    ]

    const entityStatusOptions = [
        { label: "Accepted", value: "Accepted" },
        { label: "Rejected", value: "Rejected" },
    ]

    const documentOptions = [
        { label: "Standard", value: "Standard" },
        { label: "Cover Sheet", value: "Cover Sheet" },
        { label: "Non-English", value: "Non-English" },
    ]

    const handleFileReview = (fileId) => {

        const selectedFileData = entityListData.responseData.find((item) => item.evidenceId === fileId)

        setSelectedObject(selectedFileData)
        setShowWebpageReviewModal(true)
    }

    const handleViewFile = (file) => {
        dispatch(downloadFailedFilesReset())
        const payload = {
            clientSourceListId: file?.evidenceId
        }
        dispatch(DownloadFailedFile(payload))
        if (file?.s3FileName?.endsWith(".pdf") || file?.s3FileName?.endsWith(".zip")) {
            setShowPDFPreview(true)
        }
    }

    const handleFormatClick = (entity) => {
        setSelectedObject(entity);
        if (entity?.isWebpage && entity?.sourceUrl) {
            window.open(entity.sourceUrl, "_blank", "noopener,noreferrer");
        } else if (entity?.evidenceId) {
            handleViewFile(entity);
        }
    };

    const handleConfirmSubmit = () => {
        const { type, payload } = showDocSubmissionModal || {};
        if (!type || !payload) return;
        if (type === "validate") {
            dispatch(CompleteReview(showDocSubmissionModal?.payload))
        }
        if (type === "Review") {
            dispatch(UpdateDocsFormData(showDocSubmissionModal?.payload))
        }
        if (type === "Non-FormData Review") {
            dispatch(UpdateDocsData({ payload: showDocSubmissionModal?.payload }))
        }
    }

    const handleRejectUpload = () => {
        setClearTrigger(prev => !prev);
    }

    const handleValidate = (entity) => {
        setSelectedObject(entity)
        if (entity.nestedDocumentsData.length < 1 && entity.isWebpage && !entity?.s3FileName) return;
        setShowValidateModal(true)
    }

    const handleViewDetails = (entity) => {
        setSelectedObject(entity);
        setShowViewDetailsModal(true);
    }

    const tableStructuredData = (tableData) => {
        const formattedData = tableData.map((entity) => {
            const applicableVariables = entity?.variables?.applicableVariables || [];
            const { s3FileName, additionalFields } = entity;
            return {
                key: entity.id,
                fileNameRaw: entity.isWebpage ? entity.sourceUrl || '' : entity.s3FileName || '',
                fileName: (
                    <div title={entity.isWebpage ? entity.sourceUrl : s3FileName} className="table-file-name">
                        {entity.isWebpage ? `Webpage URL - ${truncateUrl(entity.sourceUrl)}` : s3FileName?.endsWith('.zip') ? `${s3FileName} / ${additionalFields?.extractedFileName}` : s3FileName}
                    </div>
                ),
                fileCount: ((entity?.isWebpage && entity?.s3FileName) || !entity?.isWebpage) ? "1" : entity?.nestedDocumentsData?.length,
                entityName: entity.entityName || "-",
                assessmentType: entity?.assessment_type || "-",
                parent: <TruncatingVariableList variables={applicableVariables} />,
                parentRaw: applicableVariables?.join(', '),
                message: entity.uploadStatusMessage || "-",
                format: (
                    <div
                        className="format-section"
                        onClick={() => handleFormatClick(entity)}
                        title={entity.isWebpage ? 'Open Webpage' : 'Preview File'}
                        style={{ cursor: 'pointer' }}
                    >
                        {entity.isWebpage ? (
                            <RxGlobe size={20} className="gradient-icon" />
                        ) : (
                            <img
                                className="icons esg-source"
                                src={ESGSourceIcon}
                                alt="ESG file icon"
                            />
                        )}
                    </div>
                ),
                reviewStatus: entity.reviewStatus,
                reviewedBy: entity.validatedBy ? entity.validatedBy : "-",
                actions: (
                    <>
                        {entity?.reviewStatus !== "Reviewed" && (
                            <div className={`action-icons-container ${(entity?.uploadStatus === "Success" || entity?.uploadStatus === "Failed") ? "" : ""}`}>
                                {entity?.uploadStatus !== "Success" && <div className="form-button-default" onClick={() => handleFileReview(entity.evidenceId)}>{entity?.isWebpage ? "Link Review" : "File Review"}</div>}
                                {entity?.uploadStatus !== "Failed" && <div className={`form-button-default ${(entity?.nestedDocumentsData.length < 1 && entity?.isWebpage && !entity?.s3FileName) ? "disabled" : ""}`} onClick={() => handleValidate(entity)}>Entity/FY Review</div>}
                            </div>
                        )}
                        {entity?.reviewStatus === "Reviewed" && (
                            <div className="action-icons-container">
                                <div className="form-button-default" onClick={() => handleViewDetails(entity)}>View Details</div>
                            </div>
                        )}
                    </>
                )
            }
        })
        return formattedData;
    }

    const handleConfirmDelete = () => {
        const payload = {
            clientSourceListId: selectedObject?.evidenceId,
            nestedSourceId: deleteFile?.nestedSourceId
        }
        dispatch(DeleteUploadedFile(payload))
    }

    const handleEntityChange = (e) => {
        setSelectedEntity(e)
    }

    const handleStatusChange = (e) => {
        setStatus(e)
    }

    const handleDocumentTypeChange = (e) => {
        setSelectedDocument(e)
    }

    const handleFormatChange = (e) => {
        setSelectedFormat(e)
    }

    const handleVariableChange = (e) => {
        setSelectedVariables(e);
    };

    const handleEntityStatusChange = (e) => {
        setSelectedEntityStatus(e)
    }

    const handleFyStatusChange = (e) => {
        setSelectedFyStatus(e)
    }

    const handleShowFiltersSection = () => {
        setShowFilters(!showFilters)
    }

    const handleReviewStatusChange = (e) => {
        setReviewStatus(e)
    }

    const handleAssessmentTypeChange = (e) => {
        setSelectedAssessmentType(e)
    }

    const disableApply = !status && !selectedFormat && !selectedEntityStatus && !selectedAssessmentType && !selectedFyStatus && !reviewStatus && selectedEntity?.length < 1 && selectedVariables?.length < 1 && selectedDocument?.length < 1;

    const handleApplyFilters = () => {
        if (entityListLoading) return;
        if (disableApply) {
            message.error("Please select at least one filter");
            return;
        }
        setPage(1);
        setLimit(200);
        setClearTrigger(false);
        const payload = {
            page: 1,
            limit: 200,
            assessmentType: selectedAssessmentType ? [selectedAssessmentType] : [],
            processingStatus: status ? status : "",
            format: selectedFormat ? selectedFormat : "",
            entityStatus: selectedEntityStatus ? selectedEntityStatus : "",
            fyStatus: selectedFyStatus ? selectedFyStatus : "",
            reviewStatus: reviewStatus ? reviewStatus : "",
            entity_Ids: selectedEntity ? selectedEntity?.map((item) => item?.value) : [],
            variables: selectedVariables ? selectedVariables : [],
            docType: selectedDocument ? selectedDocument : []
        }
        dispatch(entityFilesList(payload))
    }

    const handleResetFilters = () => {
        dispatch(entityFilesListReset());
        setPage(1);
        setSelectedEntity([]);
        setSelectedAssessmentType(null);
        setStatus(null);
        setSelectedFormat(null);
        setSelectedEntityStatus(null);
        setSelectedFyStatus(null);
        setReviewStatus(null);
        setSelectedDocument([]);
        setSelectedObject(null);
        setSelectedVariables([]);
        setFormattedTableData({ dataSource: [], columns: tableHeaderData })
    }

    const handleExportReport = () => {
        if (exportDocReviewLoading) return;
        const payload = {
            isExport: true,
            processingStatus: status ? status : "",
            page: page,
            limit: limit,
            assessmentType: selectedAssessmentType ? [selectedAssessmentType] : [],
            format: selectedFormat ? selectedFormat : "",
            entityStatus: selectedEntityStatus ? selectedEntityStatus : "",
            fyStatus: selectedFyStatus ? selectedFyStatus : "",
            reviewStatus: reviewStatus ? reviewStatus : "",
            entity_Ids: selectedEntity ? selectedEntity?.map((item) => item?.value) : [],
            variables: selectedVariables ? selectedVariables : [],
            docType: selectedDocument ? selectedDocument : []
        }
        dispatch(DocReviewExportAction(payload))
    }

    useEffect(() => {
        if (!variableInitialized || disableApply) return;
        const payload = {
            page: page,
            limit: limit,
            processingStatus: status ? status : "",
            assessmentType: selectedAssessmentType ? [selectedAssessmentType] : [],
            format: selectedFormat ? selectedFormat : "",
            entityStatus: selectedEntityStatus ? selectedEntityStatus : "",
            fyStatus: selectedFyStatus ? selectedFyStatus : "",
            reviewStatus: reviewStatus ? reviewStatus : "",
            entity_Ids: selectedEntity ? selectedEntity?.map((item) => item?.value) : [],
            variables: selectedVariables ? selectedVariables : [],
            docType: selectedDocument ? selectedDocument : []
        }
        dispatch(entityFilesList(payload))
    }, [page, limit, variableInitialized])

    const triggerDownload = (url) => {
        const link = document.createElement("a");
        link.href = url;
        link.download = '';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    useEffect(() => {
        if (!failedFile?.url?.url) return;
        if (selectedObject?.isWebpage && shouldDownload) {
            triggerDownload(failedFile?.url?.url)
            setShouldDownload(false);
            dispatch(downloadFailedFilesReset());
        } else if (selectedObject?.s3FileName && !selectedObject?.s3FileName?.endsWith(".pdf") && !selectedObject?.s3FileName?.endsWith(".zip")) {
            triggerDownload(failedFile?.url?.url);
            dispatch(downloadFailedFilesReset());
        }
    }, [failedFile]);

    useEffect(() => {
        dispatch(entityList())
        dispatch(entityFilesListReset());
        dispatch(reviewFileReset())
        dispatch(completeReviewReset())
        dispatch(fileValidationReset());
        if (variable) setSelectedVariables(variable);
        if (entity) setSelectedEntity(entity);
        setVariableInitialized(true);
        dispatch(resetFilterValueNavigationState());
    }, []);

    useEffect(() => {
        if (fileValidationError) {
            message.error(fileValidationError?.message)
        }
        if (fileValidationData?.confirmationPopupRequired === true) {
            setShowUploadConfirmationModal(true)
            setClearTrigger(false)
        } else if (fileValidationData?.confirmationPopupRequired === false) {
            setShowUploadConfirmationModal(false);
        }
    }, [fileValidationError, fileValidationSuccess, fileValidationData])

    useEffect(() => {
        if (entityListData?.responseData) {
            const formattedData = entityListData?.responseData
                ? tableStructuredData(entityListData?.responseData)
                : [];
            setFormattedTableData({
                dataSource: formattedData,
                columns: tableHeaderData
            });
        } else {
            setFormattedTableData({
                dataSource: [],
                columns: tableHeaderData
            })
        }
    }, [entityListData?.responseData])

    useEffect(() => {
        if (deleteFileError) {
            message.error(deleteFileError?.message);
            dispatch(deleteFileReset())
        }
        if (deleteFileSuccess) {
            message.success(deleteFileData?.message)
            dispatch(deleteFileReset())
            setShowDeleteFileModal(false)
            setSelectedObject((prev) => ({
                ...prev,
                nestedDocumentsData: prev.nestedDocumentsData?.filter(
                    (file) => file?.nestedSourceId !== deleteFile?.nestedSourceId
                )
            }));
            handleApplyFilters();
        }
    }, [deleteFileError, deleteFileSuccess])

    useEffect(() => {
        if (updateDocsError) {
            message.error(updateDocsError?.message);
            dispatch(updateDocsDataReset())
        }
        if (updateDocsSuccess) {
            message.success(updateDocsData?.message);
            dispatch(updateDocsDataReset());
            setShowViewDetailsModal(false);
            setShowDocSubmissionModal({
                show: false
            })
            handleApplyFilters();
        }
        if (updateDocsFormDataError) {
            message.error(updateDocsFormDataError?.message);
            dispatch(updateDocsFormdataReset());
        }
        if (updateDocsFormDataSuccess) {
            message.success(updateDocsFormData?.message);
            dispatch(updateDocsFormdataReset());
            setShowViewDetailsModal(false);
            setShowDocSubmissionModal({
                show: false
            })
            handleApplyFilters();
        }
    }, [updateDocsError, updateDocsSuccess, updateDocsFormDataError, updateDocsFormDataSuccess])

    useEffect(() => {
        if (fileSubmitError) {
            message.error(fileSubmitError?.message);
            dispatch(reviewFileReset())
        }
        if (fileSubmitSuccess) {
            message.success(fileSubmitData?.message);
            dispatch(reviewFileReset())
            setShowWebpageReviewModal(false)
            handleApplyFilters();
        }
    }, [fileSubmitError, fileSubmitSuccess])

    useEffect(() => {
        if (completeReviewError) {
            message.error(completeReviewError?.message)
            dispatch(completeReviewReset())
        }
        if (completeReviewSuccess) {
            message.success(completeReviewData?.message)
            dispatch(completeReviewReset())
            setShowValidateModal(false)
            setShowReviewSubmissionModal(false)
            setShowDocSubmissionModal({
                show: false
            })
            handleApplyFilters();
        }
    }, [completeReviewSuccess, completeReviewError])

    useEffect(() => {
        if (exportDocReviewError) {
            message.error(exportDocReviewError?.message);
            dispatch(docReviewExportReset());
        }
    }, [exportDocReviewError])

    return (
        <div className="output-review-main">
            <Breadcrumbs breadcrumbDetails={menuData} />
            <div className="review-output-filters">
                {
                    showFilters && (
                        <div className="filters-section">
                            <div className="review-screen-filters-section">
                                <div className="input-wrapper">
                                    <div className="input-label">
                                        Assessment Type
                                    </div>
                                    <div className="input-container">
                                        <Select
                                            showSearch
                                            allowClear
                                            className="filter-select"
                                            options={assessmentTypeOptions}
                                            onChange={handleAssessmentTypeChange}
                                            value={selectedAssessmentType}
                                            placeholder="Select Type"
                                            filterOption={(input, option) => option?.label?.toLowerCase()?.includes(input?.toLowerCase())}
                                        />
                                    </div>
                                </div>
                                <div className="input-wrapper">
                                    <div className="input-label">
                                        File Review Status
                                    </div>
                                    <div className="input-container">
                                        <Select
                                            showSearch
                                            allowClear
                                            className="filter-select"
                                            options={fileReviewOptions}
                                            onChange={handleReviewStatusChange}
                                            value={reviewStatus}
                                            placeholder="Select Status"
                                            filterOption={(input, option) => option?.label?.toLowerCase()?.includes(input?.toLowerCase())}
                                        />
                                    </div>
                                </div>
                                <div className="input-wrapper">
                                    <div className="input-label">
                                        File Processing Status
                                    </div>
                                    <div className="input-container">
                                        <Select
                                            showSearch
                                            allowClear
                                            className="filter-select"
                                            options={statusOptions}
                                            onChange={handleStatusChange}
                                            value={status}
                                            placeholder="Select Status"
                                            filterOption={(input, option) => option?.label?.toLowerCase()?.includes(input?.toLowerCase())}
                                        />
                                    </div>
                                </div>
                                <div className="input-wrapper">
                                    <div className="input-label">
                                        Entity
                                    </div>
                                    <div className="input-container">
                                        <Select
                                            showSearch
                                            allowClear
                                            labelInValue
                                            mode="multiple"
                                            maxTagCount={1}
                                            className="filter-select"
                                            options={entityDropdownData?.responseData}
                                            onChange={handleEntityChange}
                                            value={selectedEntity}
                                            placeholder="Select Entity"
                                            filterOption={(input, option) => option?.label?.toLowerCase()?.includes(input?.toLowerCase())}
                                            notFoundContent={entityLoading ? <div className="dropdown-loading"><Spin size="small" /></div> : <div className="dropdown-loading">No Data</div>}
                                        />
                                    </div>
                                </div>
                                <div className="input-wrapper">
                                    <div className="input-label">
                                        Format
                                    </div>
                                    <div className="input-container">
                                        <Select
                                            showSearch
                                            allowClear
                                            className="filter-select"
                                            options={formatOptions}
                                            onChange={handleFormatChange}
                                            value={selectedFormat}
                                            placeholder="Select Format"
                                            filterOption={(input, option) => option?.label?.toLowerCase()?.includes(input?.toLowerCase())}
                                        />
                                    </div>
                                </div>
                                <div className="input-wrapper">
                                    <div className="input-label">
                                        Entity Status
                                    </div>
                                    <div className="input-container">
                                        <Select
                                            showSearch
                                            allowClear
                                            className="filter-select"
                                            options={entityStatusOptions}
                                            onChange={handleEntityStatusChange}
                                            value={selectedEntityStatus}
                                            placeholder="Select Status"
                                            filterOption={(input, option) => option?.label?.toLowerCase()?.includes(input?.toLowerCase())}
                                        />
                                    </div>
                                </div>
                                <div className="input-wrapper">
                                    <div className="input-label">
                                        FY Status
                                    </div>
                                    <div className="input-container">
                                        <Select
                                            showSearch
                                            allowClear
                                            className="filter-select"
                                            options={entityStatusOptions}
                                            onChange={handleFyStatusChange}
                                            value={selectedFyStatus}
                                            placeholder="Select Status"
                                            filterOption={(input, option) => option?.label?.toLowerCase()?.includes(input?.toLowerCase())}
                                        />
                                    </div>
                                </div>
                                <div className="input-wrapper">
                                    <div className="input-label">
                                        Parent
                                    </div>
                                    <div className="input-container">
                                        <Select
                                            showSearch
                                            allowClear
                                            mode="multiple"
                                            maxTagCount={1}
                                            className="filter-select"
                                            options={entityDropdownData?.variables}
                                            onChange={handleVariableChange}
                                            value={selectedVariables}
                                            placeholder="Select Variable"
                                            filterOption={(input, option) => option?.label?.toLowerCase()?.includes(input?.toLowerCase())}
                                        />
                                    </div>
                                </div>
                                <div className="input-wrapper">
                                    <div className="input-label">
                                        Document Type
                                    </div>
                                    <div className="input-container">
                                        <Select
                                            showSearch
                                            allowClear
                                            mode="multiple"
                                            maxTagCount={1}
                                            className="filter-select"
                                            options={documentOptions}
                                            onChange={handleDocumentTypeChange}
                                            value={selectedDocument}
                                            placeholder="Select Type"
                                            filterOption={(input, option) => option?.label?.toLowerCase()?.includes(input?.toLowerCase())}
                                        />
                                    </div>
                                </div>
                                <div className="filter-buttons-wrapper">
                                    <div className={`button-wrapper ${(entityListLoading || disableApply) ? "export-disabled" : ""}`} onClick={() => handleApplyFilters()}>Apply</div>
                                    <div className="button-wrapper" onClick={() => handleResetFilters()}>Reset</div>
                                </div>
                            </div>
                            <div className="filter-buttons-section content-buttons-left">
                                <div className="button-wrapper export" onClick={handleExportReport}>
                                    {exportDocReviewLoading ? <Spin className="export" indicator={antIcon} /> : <PiExportBold />}
                                    Export
                                </div>
                            </div>
                        </div>
                    )
                }
                <ManageFilters showFilters={showFilters} handleShowFiltersSection={handleShowFiltersSection} customStyle={{ display: 'flex' }} />
            </div>
            <div className="review-output-table-section">
                <CustomTable
                    page={page}
                    setPage={setPage}
                    limit={limit}
                    setLimit={setLimit}
                    tableData={formattedTableData}
                    isLoading={entityListLoading}
                    totalRows={entityListData?.totalCount}
                />
            </div>

            {showWebpageReviewModal && (
                <CustomModal showCloseIcon handleClose={() => setShowWebpageReviewModal(false)} modalTitle={selectedObject?.isWebpage ? "Webpage Review / File Upload" : (selectedObject?.s3FileName?.endsWith('.zip') ? `${selectedObject?.s3FileName} / ${selectedObject?.additionalFields?.extractedFileName}` : selectedObject?.s3FileName)}>
                    <FileReviewModal
                        selectedSource={selectedObject}
                        handleClose={() => setShowWebpageReviewModal(false)}
                        isLoading={fileSubmitLoading || fileSubmitLoading || completeReviewLoading}
                        documentList={documentList}
                        setDocumentList={setDocumentList}
                        setShowPDFPreview={setShowPDFPreview}
                        linkStatus={linkStatus}
                        setLinkStatus={setLinkStatus}
                        fileStatus={fileStatus}
                        setFileStatus={setFileStatus}
                        setDeleteFile={setDeleteFile}
                        setShowDeleteFileModal={setShowDeleteFileModal}
                        clearTrigger={clearTrigger}
                        setShowUploadConfirmationModal={setShowUploadConfirmationModal}
                        fileValidationLoading={fileValidationLoading}
                        copiedId={copiedId}
                        setCopiedId={setCopiedId}
                        setShouldDownload={setShouldDownload}
                    />
                </CustomModal>
            )}

            {showValidateModal && (
                <CustomModal showCloseIcon modalTitle={selectedObject?.isWebpage ? "Webpage URL" : (selectedObject?.s3FileName?.endsWith('.zip') ? `${selectedObject?.s3FileName} / ${selectedObject?.additionalFields?.extractedFileName}` : selectedObject?.s3FileName)} handleClose={() => { setShowValidateModal(false) }}>
                    <ValidateModal
                        handleClose={() => setShowValidateModal(false)}
                        selectedSource={selectedObject}
                        setShowValidateModal={setShowValidateModal}
                        setShowReviewSubmissionModal={setShowReviewSubmissionModal}
                        setShowPDFPreview={setShowPDFPreview}
                        showPDFPreview={showPDFPreview}
                        radioValues={radioValues}
                        setRadioValues={setRadioValues}
                        rejectReason={rejectReason}
                        setRejectReason={setRejectReason}
                        completeReviewLoading={completeReviewLoading}
                        fileValidationLoading={fileValidationLoading}
                        documentList={documentList}
                        setDocumentList={setDocumentList}
                        setDeleteFile={setDeleteFile}
                        setShowDeleteFileModal={setShowDeleteFileModal}
                        copiedId={copiedId}
                        setCopiedId={setCopiedId}
                        clearTrigger={clearTrigger}
                        setShowUploadConfirmationModal={setShowUploadConfirmationModal}
                        setShowDocSubmissionModal={setShowDocSubmissionModal}
                        setShouldDownload={setShouldDownload}
                    />
                </CustomModal>
            )}


            {showReviewSubmissionModal && (
                <CustomModal showCloseIcon handleClose={() => setShowReviewSubmissionModal(false)} modalTitle={<div className="modal-title">
                    <div className="modal-icon">
                        <PiWarningCircleLight />
                    </div>
                    Confirm
                </div>}>
                    <ReviewSubmissionModal handleClose={() => setShowReviewSubmissionModal(false)}
                        radioValues={radioValues}
                        setRadioValues={setRadioValues}
                        rejectReason={rejectReason}
                        setRejectReason={setRejectReason}
                        selectedSource={selectedObject}
                        isLoading={completeReviewLoading}
                    />
                </CustomModal>
            )}

            {showViewDetailsModal && (
                <CustomModal showCloseIcon handleClose={() => setShowViewDetailsModal(false)} modalTitle={selectedObject?.isWebpage ? "Webpage URL" : (selectedObject?.s3FileName?.endsWith('.zip') ? `${selectedObject?.s3FileName} / ${selectedObject?.additionalFields?.extractedFileName}` : selectedObject?.s3FileName)}>
                    <ViewDetailsModal
                        handleClose={() => setShowViewDetailsModal(false)}
                        selectedSource={selectedObject}
                        setShowPDFPreview={setShowPDFPreview}
                        radioValues={radioValues}
                        rejectReason={rejectReason}
                        setDeleteFile={setDeleteFile}
                        setShowDeleteFileModal={setShowDeleteFileModal}
                        copiedId={copiedId}
                        setCopiedId={setCopiedId}
                        fileValidationLoading={fileValidationLoading}
                        clearTrigger={clearTrigger}
                        setShowUploadConfirmationModal={setShowUploadConfirmationModal}
                        documentList={documentList}
                        setDocumentList={setDocumentList}
                        updateDocsLoading={updateDocsLoading}
                        updateDocsFormDataLoading={updateDocsFormDataLoading}
                        setShowDocSubmissionModal={setShowDocSubmissionModal}
                        setShouldDownload={setShouldDownload}
                    />
                </CustomModal>
            )}

            {showDeleteFileModal && (
                <CustomModal
                    showCloseIcon
                    handleClose={() => setShowDeleteFileModal(false)}
                    modalTitle={
                        <div className="modal-title">
                            <div className="modal-icon">
                                <PiWarningCircleLight />
                            </div>
                            Confirm
                        </div>
                    }
                >
                    <ConfirmationModal
                        handleClose={() => setShowDeleteFileModal(false)}
                        handleConfirm={handleConfirmDelete}
                        isLoading={deleteFileLoading}
                        message={
                            <>
                                Are you sure you want to delete <strong>{deleteFile?.fileName || " "}</strong>?
                            </>
                        }
                    />
                </CustomModal>
            )}

            {showUploadConfirmationModal && (
                <CustomModal
                    showCloseIcon
                    handleClose={handleRejectUpload}
                    modalTitle={
                        <div className="modal-title">
                            <div className="modal-icon">
                                <PiWarningCircleLight />
                            </div>
                            Confirm
                        </div>
                    }
                >
                    <UploadConfirmationModal
                        handleClose={() => setShowUploadConfirmationModal(false)}
                        handleUpload={handleRejectUpload}
                        message={fileValidationData?.message}
                    />
                </CustomModal>
            )}

            {showDocSubmissionModal?.show && (
                <CustomModal
                    showCloseIcon
                    handleClose={() => setShowDocSubmissionModal({
                        show: false
                    })}
                    modalTitle={
                        <div className="modal-title">
                            <div className="modal-icon">
                                <PiWarningCircleLight />
                            </div>
                            Confirm
                        </div>
                    }
                >
                    <DocSubmissionModal
                        handleClose={() => setShowDocSubmissionModal({
                            show: false
                        })}
                        handleConfirmSubmit={handleConfirmSubmit}
                        isLoading={updateDocsFormDataLoading || completeReviewLoading || updateDocsLoading}
                        message={
                            <>
                                By submitting this, you confirm that the document is neither a coversheet nor in a non-English language. Do you wish to proceed?
                            </>
                        }
                    />
                </CustomModal>
            )}

            {showPDFPreview && (
                <PDFPreview setShow={setShowPDFPreview}
                //  restrictDownload={!selectedObject?.isWebpage} 
                />
            )}
        </div>
    )
}

export default ReviewEntities;